// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonitoringDashboardModal_overlay__NmG5Y {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.MonitoringDashboardModal_modal__LDvh2 {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 1400px;        /* CriteriaModal 과 통일 */
  height: calc(80vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.MonitoringDashboardModal_header__f48Tr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.MonitoringDashboardModal_header__f48Tr h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  flex: 1 1;
}

.MonitoringDashboardModal_headerControls__\\+mfLN {
  display: flex;
  gap: 12px;
  align-items: center;
}

.MonitoringDashboardModal_connSelect__GQVPX {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background: white;
  cursor: pointer;
  min-width: 150px;
}

/* 헤더의 시간축 동기화 체크박스 — connSelect 옆 inline. */
.MonitoringDashboardModal_syncCheckLabel__oKpgM {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  padding: 0 4px;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.MonitoringDashboardModal_syncCheckLabel__oKpgM input { cursor: pointer; }
[data-theme="dark"] .MonitoringDashboardModal_syncCheckLabel__oKpgM { color: var(--color-text-secondary); }

.MonitoringDashboardModal_connSelect__GQVPX:hover {
  border-color: #3b82f6;
}

.MonitoringDashboardModal_connSelect__GQVPX:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.MonitoringDashboardModal_refreshBtn__5NDuB,
.MonitoringDashboardModal_closeBtn__ygfjU {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.MonitoringDashboardModal_closeBtn__ygfjU {
  font-size: 18px;
}

.MonitoringDashboardModal_refreshBtn__5NDuB:hover:not(:disabled),
.MonitoringDashboardModal_closeBtn__ygfjU:hover {
  color: #333;
}

.MonitoringDashboardModal_refreshBtn__5NDuB:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.MonitoringDashboardModal_refreshBtn__5NDuB:disabled svg {
  animation: MonitoringDashboardModal_spin__LOZV4 1s linear infinite;
}

@keyframes MonitoringDashboardModal_spin__LOZV4 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.MonitoringDashboardModal_body__u\\+tuT {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.MonitoringDashboardModal_metricsGrid__U\\+tgx {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.MonitoringDashboardModal_chartsContainer__kQdh1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.MonitoringDashboardModal_chartSection__PVQWu {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  /* 자식이 남은 공간을 채워 차트가 셀 크기에 맞춰 확장되도록 flex column */
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

/* 차트 또는 placeholder 가 차지하는 영역 — 헤더 제외한 나머지 공간 모두 사용 */
.MonitoringDashboardModal_panelChartWrapper__1FyDy {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* \`.chartSection h3\` 은 직속 자식에만 적용 — 손자 h3(\`.panelHeader h3\`)의
   font-size: 14px 와 동일 specificity 였던 게 source order 의존이라
   CSS Module/HMR 시 가끔 16px 가 이기는 경우가 있어 직속(\`>\`) 으로 한정. */
.MonitoringDashboardModal_chartSection__PVQWu > h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #1f2937;
}

.MonitoringDashboardModal_noData__AWw1I {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 14px;
}

.MonitoringDashboardModal_footer__zHwI4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  gap: 16px;
}

.MonitoringDashboardModal_autoRefreshControl__dSNhm {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #374151;
}

.MonitoringDashboardModal_autoRefreshControl__dSNhm label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.MonitoringDashboardModal_autoRefreshControl__dSNhm input {
  cursor: pointer;
}

.MonitoringDashboardModal_intervalSelect__KtBFH {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.MonitoringDashboardModal_timestamp__kXY8g {
  font-size: 12px;
  color: #9ca3af;
}

/* ===== 탭 바 ===== */
.MonitoringDashboardModal_tabBar__Sulzk {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 6px 12px;
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  overflow-x: auto;
}

.MonitoringDashboardModal_tabItem__THfAv {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px 2px 2px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
}

.MonitoringDashboardModal_tabActive__NPiHX {
  border-color: #3b82f6;
  background: #dbeafe;
}

.MonitoringDashboardModal_tabMain__o9NY0 {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  padding: 4px 8px;
  /* 아이콘(span) + 텍스트 노드 수직 중앙 정렬 — baseline 어긋남 방지 */
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.MonitoringDashboardModal_tabMain__o9NY0:hover {
  color: #1f2937;
}

.MonitoringDashboardModal_tabRotationLabel__HqIAv {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0 2px;
}

.MonitoringDashboardModal_tabRotationLabel__HqIAv input {
  cursor: pointer;
}

.MonitoringDashboardModal_tabActionBtn__bSNpv {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  padding: 3px;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
}

.MonitoringDashboardModal_tabActionBtn__bSNpv:hover {
  background: #e5e7eb;
  color: #1f2937;
}

/* ===== 패널 그리드 ===== */
.MonitoringDashboardModal_panelGrid__OxzGj {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  grid-auto-rows: minmax(350px, 1fr);
  gap: 16px;
  /* flex 부모(body / 분리 popup wrapper) 안에서 남은 세로 공간 채우도록.
     grid-auto-rows 의 minmax(350px) 가 컨테이너 보다 큰 경우 collapsedStrip 영역으로
     overflow 되어 시각적 겹침이 보일 수 있어 overflow-y: auto 로 내부 스크롤 처리. */
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.MonitoringDashboardModal_panelHeader__tig-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 10px 0;
  flex-shrink: 0;
}

.MonitoringDashboardModal_panelHeader__tig-2 h3 {
  margin: 0;
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}

/* 제목 + publisher 배지를 묶은 영역 — 정렬은 inline justifyContent 로 결정 */
.MonitoringDashboardModal_panelTitleWrapper__OBtmv {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 드래그 핸들 — 카드 헤더 좌측. 마우스 올리면 진하게 */
.MonitoringDashboardModal_panelDragHandle__nTtm7 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  cursor: grab;
  padding: 2px 4px;
  margin-right: 8px;   /* 제목과 시각적 간격 — 핸들과 텍스트 붙어보이지 않도록 */
  border-radius: 3px;
  transition: color 160ms ease, background-color 160ms ease;
}
.MonitoringDashboardModal_panelDragHandle__nTtm7:hover { color: #374151; background: #e5e7eb; }
.MonitoringDashboardModal_panelDragHandle__nTtm7:active { cursor: grabbing; }

/* 드래그 중 카드 — 반투명으로 피드백 */
.MonitoringDashboardModal_chartSectionDragging__Nd64p {
  opacity: 0.45;
}

/* 슬롯 셀 래퍼 — drop zone 컨테이너 (flex 자식이라 grid cell 자리 그대로) */
.MonitoringDashboardModal_slotCell__iH6V3 {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  transition: outline-color 160ms ease, background-color 160ms ease;
  outline: 2px solid transparent;
  outline-offset: -2px;
  border-radius: 8px;
}
.MonitoringDashboardModal_slotCellDropActive__F\\+5q0 {
  outline-color: #3b82f6;
  background: rgba(59, 130, 246, 0.06);
}
.MonitoringDashboardModal_slotCell__iH6V3 > * {
  /* slotCell(flex-column) 안에서 자식이 남은 공간을 채우되,
     padding/border 가 높이에 포함되도록 border-box — 안 그러면 content-box 기본값이라
     chartSection 의 padding(16px) / emptySlot 의 border(2px) 가 더해져 부모 셀 밖으로 넘침 */
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

/* 슬롯 그리드 안의 placeholder/emptySlot 들은 자체 min-height (260/200px) 를
   가지고 있어, popup 처럼 좁은 컨테이너에서 row 보다 큰 콘텐츠가 되어
   인접 셀 또는 하단 strip 으로 시각적 overflow 발생.
   slotCell 컨텍스트 에서는 min-height 를 풀어 row 크기에 맞춰 줄어들게 한다. */
.MonitoringDashboardModal_slotCell__iH6V3 .MonitoringDashboardModal_emptySlot__Qt8mm,
.MonitoringDashboardModal_slotCell__iH6V3 .MonitoringDashboardModal_panelDisabledBody__tCExE,
.MonitoringDashboardModal_slotCell__iH6V3 .MonitoringDashboardModal_panelWaitingBody__TY\\+z- {
  min-height: 0;
}

/* 빈 슬롯이 drop target 일 때 강조 */
.MonitoringDashboardModal_emptySlotDropActive__6mEyt {
  border-color: #3b82f6 !important;
  background: rgba(59, 130, 246, 0.08) !important;
}

/* ============================================================ */
/* 접기(collapsed) 패널 strip — 그리드 아래 고정 영역             */
/* ============================================================ */
.MonitoringDashboardModal_collapsedStrip__rzfXC {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  margin-top: 12px;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  min-height: 44px;
  transition: background-color 160ms ease, border-color 160ms ease;
}
.MonitoringDashboardModal_collapsedStripDropActive__v594t {
  background: rgba(59, 130, 246, 0.08) !important;
  border-color: #3b82f6 !important;
}
.MonitoringDashboardModal_collapsedStripHint__n9eIg {
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

/* 접기 카드 — 한 줄짜리 작은 칩 형태 */
.MonitoringDashboardModal_collapsedCard__p7r4e {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  color: #1f2937;
  max-width: 320px;
  transition: opacity 160ms ease, border-color 160ms ease;
}
.MonitoringDashboardModal_collapsedCard__p7r4e:hover {
  border-color: #9ca3af;
}
.MonitoringDashboardModal_collapsedCardDragging__1vbAV { opacity: 0.45; }
.MonitoringDashboardModal_collapsedCardDisabled__1EWrH { opacity: 0.65; border-style: dashed; }

.MonitoringDashboardModal_collapsedCardDragHandle__mfwvu {
  display: inline-flex;
  align-items: center;
  color: #9ca3af;
  cursor: grab;
  padding: 1px 2px;
  border-radius: 2px;
}
.MonitoringDashboardModal_collapsedCardDragHandle__mfwvu:hover { color: #374151; background: #e5e7eb; }
.MonitoringDashboardModal_collapsedCardDragHandle__mfwvu:active { cursor: grabbing; }

.MonitoringDashboardModal_collapsedCardTitle__hE3eF {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

/* + 패널 추가 버튼 (strip 좌측 고정) */
.MonitoringDashboardModal_collapsedAddBtn__1Cd6K {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 160ms ease, border-color 160ms ease;
}
.MonitoringDashboardModal_collapsedAddBtn__1Cd6K:hover {
  background: #2563eb;
  border-color: #2563eb;
}

/* 다크 모드 */
[data-theme="dark"] .MonitoringDashboardModal_collapsedStrip__rzfXC {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_collapsedStripHint__n9eIg {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_collapsedCard__p7r4e {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_collapsedCard__p7r4e:hover {
  border-color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_collapsedCardDragHandle__mfwvu {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_collapsedCardDragHandle__mfwvu:hover {
  color: var(--color-text);
  background: var(--color-hover);
}

@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_collapsedCard__p7r4e,
  .MonitoringDashboardModal_collapsedAddBtn__1Cd6K { transition: none; }
}

@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_panelDragHandle__nTtm7,
  .MonitoringDashboardModal_slotCell__iH6V3 { transition: none; }
}

.MonitoringDashboardModal_panelEditBtn__HELeB {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
}

.MonitoringDashboardModal_panelEditBtn__HELeB:hover {
  background: #e5e7eb;
  color: #1f2937;
}

/* 패널 활성/비활성 토글 버튼 — 편집 아이콘 옆 위치.
   색상 부드러운 전환 (UI Conventions: 150~180ms ease, 색상 한정). */
.MonitoringDashboardModal_panelToggleBtn__kMhdj {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #9ca3af;
  padding: 4px;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  margin-right: 2px;
  transition: color 160ms ease, background-color 160ms ease;
}
.MonitoringDashboardModal_panelToggleBtn__kMhdj:hover {
  background: #e5e7eb;
}
.MonitoringDashboardModal_panelToggleBtnOn__gNzT0 {
  color: #10b981;
}

/* 비활성 카드 — 살짝 디밍 + 점선 테두리로 시각 구분 */
.MonitoringDashboardModal_chartSectionDisabled__86h2X {
  opacity: 0.7;
  border-style: dashed;
}

/* 비활성 패널 자리 표시 — 차트 자리에 안내 문구 */
.MonitoringDashboardModal_panelDisabledBody__tCExE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 12px;
  color: #9ca3af;
  font-size: 12px;
  min-height: 200px;
  flex: 1 1;          /* 카드 셀이 커지면 placeholder 도 같이 늘어남 */
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
  /* fade-in (UI Conventions: 120~200ms) */
  animation: MonitoringDashboardModal_panelToggleFade__bAPG- 160ms ease-out;
}
@keyframes MonitoringDashboardModal_panelToggleFade__bAPG- {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* 변수 대기 placeholder — 다른 패널 클릭 기다리는 중 */
.MonitoringDashboardModal_panelWaitingBody__TY\\+z- {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 28px 12px;
  color: #6b7280;
  font-size: 12px;
  min-height: 200px;
  flex: 1 1;          /* 카드 셀에 맞춰 확장 */
  border: 1px dashed #fbbf24;
  background: #fffbeb;
  border-radius: 6px;
  animation: MonitoringDashboardModal_panelToggleFade__bAPG- 160ms ease-out;
}
.MonitoringDashboardModal_panelWaitingBody__TY\\+z- small {
  color: #92400e;
  font-size: 11px;
}

/* publisher 패널 헤더 배지 — 클릭 시 :var 발행 시각 힌트 */
.MonitoringDashboardModal_panelPublisherBadge__YzLUD {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 6px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 3px;
  color: #1e40af;
  font-size: 10px;
  font-weight: 500;
  font-family: var(--font-mono);
  white-space: nowrap;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
/* 현재 발행값 부분 — 약간 더 진하게 강조 */
.MonitoringDashboardModal_panelPublisherBadgeValue__HKWwK {
  margin-left: 2px;
  font-weight: 700;
  color: #1e3a8a;
}
[data-theme="dark"] .MonitoringDashboardModal_panelPublisherBadgeValue__HKWwK {
  color: #dbeafe;
}

/* OS-level reduced motion 선호 시 무력화 */
@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_panelToggleBtn__kMhdj,
  .MonitoringDashboardModal_panelPublisherBadge__YzLUD { transition: none; }
  .MonitoringDashboardModal_panelDisabledBody__tCExE,
  .MonitoringDashboardModal_panelWaitingBody__TY\\+z- { animation: none; }
}

/* ============================================================ */
/* SQL 보기 모달 — 패널 헤더의 SQL 아이콘 클릭 시 표시            */
/* ============================================================ */
.MonitoringDashboardModal_sqlViewOverlay__xDoBa {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  /* fade-in (UI Conventions: 120~200ms ease-out) */
  animation: MonitoringDashboardModal_sqlViewFadeIn__vyH5m 160ms ease-out;
}
@keyframes MonitoringDashboardModal_sqlViewFadeIn__vyH5m {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.MonitoringDashboardModal_sqlViewModal__xUlUG {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 880px;
  max-height: calc(80vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* slight slide-down */
  animation: MonitoringDashboardModal_sqlViewSlide__YfcvO 160ms ease-out;
}
@keyframes MonitoringDashboardModal_sqlViewSlide__YfcvO {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.MonitoringDashboardModal_sqlViewHeader__9OWmt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}
.MonitoringDashboardModal_sqlViewTitle__ibICS {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  margin-right: 8px;
}
.MonitoringDashboardModal_sqlViewActions__yImBm {
  display: inline-flex;
  gap: 4px;
  flex-shrink: 0;
}
.MonitoringDashboardModal_sqlViewIconBtn__BTEj4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}
.MonitoringDashboardModal_sqlViewIconBtn__BTEj4:hover:not(:disabled) {
  border-color: #3b82f6;
  color: #2563eb;
  background: #eff6ff;
}
.MonitoringDashboardModal_sqlViewIconBtn__BTEj4:disabled { opacity: 0.45; cursor: not-allowed; }
.MonitoringDashboardModal_sqlViewSubheader__ufb-D {
  padding: 6px 14px;
  font-size: 11px;
  color: #6b7280;
  background: #fefce8;
  border-bottom: 1px solid #fde68a;
}
.MonitoringDashboardModal_sqlViewSubheader__ufb-D code {
  background: #fff7d6;
  padding: 0 4px;
  border-radius: 3px;
  font-size: 11px;
}
.MonitoringDashboardModal_sqlViewBody__2iMUP {
  margin: 0;
  padding: 12px 14px;
  overflow: auto;
  flex: 1 1;
  min-height: 0;
  background: #fff;
  font-family: var(--font-mono);
  font-size: 12.5px;
  line-height: 1.5;
  color: #1f2937;
  white-space: pre;
  tab-size: 2;
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewModal__xUlUG {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewHeader__9OWmt {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewTitle__ibICS { color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_sqlViewIconBtn__BTEj4 {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewIconBtn__BTEj4:hover:not(:disabled) {
  border-color: var(--color-hover-border, #5a5a5a);
  color: var(--color-text);
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewSubheader__ufb-D {
  background: rgba(245, 158, 11, 0.12);
  border-bottom-color: rgba(245, 158, 11, 0.3);
  color: #fbbf24;
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewSubheader__ufb-D code {
  background: rgba(245, 158, 11, 0.18);
  color: #fde68a;
}
[data-theme="dark"] .MonitoringDashboardModal_sqlViewBody__2iMUP {
  background: var(--color-bg);
  color: var(--color-text);
}
@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_sqlViewOverlay__xDoBa,
  .MonitoringDashboardModal_sqlViewModal__xUlUG { animation: none; }
  .MonitoringDashboardModal_sqlViewIconBtn__BTEj4 { transition: none; }
}

/* ============================================================ */
/* 병합 차트 (chartType='merged') — sub-panel 세로 stack         */
/* ============================================================ */
.MonitoringDashboardModal_mergedStack__ei8d9 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  /* sub-panel 사이 시각적 구분 — 가벼운 divider */
  gap: 4px;
}
.MonitoringDashboardModal_mergedItem__Sleqs {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* fade-in (UI Conventions: 120~200ms ease-out) */
  animation: MonitoringDashboardModal_panelToggleFade__bAPG- 160ms ease-out;
}
.MonitoringDashboardModal_mergedSubTitle__ztm54 {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  padding: 2px 4px;
  margin-bottom: 2px;
  flex-shrink: 0;
  /* 긴 제목 truncation — sub-panel 카드는 좁을 수 있음 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.MonitoringDashboardModal_mergedEmpty__rw45i {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #9ca3af;
  font-size: 12px;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
  animation: MonitoringDashboardModal_panelToggleFade__bAPG- 160ms ease-out;
}
[data-theme="dark"] .MonitoringDashboardModal_mergedSubTitle__ztm54 { color: var(--color-text-muted); }
[data-theme="dark"] .MonitoringDashboardModal_mergedEmpty__rw45i {
  color: var(--color-text-muted);
  border-color: var(--color-border);
}
@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_mergedItem__Sleqs,
  .MonitoringDashboardModal_mergedEmpty__rw45i { animation: none; }
}

.MonitoringDashboardModal_panelError__X26Bk {
  background: #fee2e2;
  color: #991b1b;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
  word-break: break-all;
}

.MonitoringDashboardModal_addPanelTile__uY70f {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #fafafa;
}

.MonitoringDashboardModal_emptyTab__bXeot {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

.MonitoringDashboardModal_emptyTab__bXeot p {
  margin-bottom: 16px;
}

/* ===== 분리 안내 ===== */
.MonitoringDashboardModal_detachedNotice__M5dva {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
  font-size: 14px;
  background: #fafafa;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
}

.MonitoringDashboardModal_detachedNotice__M5dva p {
  margin-bottom: 16px;
}

/* ===== 공통 버튼 ===== */
.MonitoringDashboardModal_btnPrimary__Uu36a,
.MonitoringDashboardModal_btnSecondary__VZX2I {
  padding: 6px 14px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.MonitoringDashboardModal_btnPrimary__Uu36a {
  background: #3b82f6;
  color: white;
  border: 1px solid #2563eb;
}

.MonitoringDashboardModal_btnPrimary__Uu36a:hover {
  background: #2563eb;
}

.MonitoringDashboardModal_btnSecondary__VZX2I {
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
}

.MonitoringDashboardModal_btnSecondary__VZX2I:hover {
  background: #f3f4f6;
}

.MonitoringDashboardModal_rotationOn__Oy1u3 {
  background: #dcfce7;
  border-color: #16a34a;
  color: #166534;
}

.MonitoringDashboardModal_rotationControl__e10Xe {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MonitoringDashboardModal_dwellLabel__kQA26 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

/* ===== 다크모드 — 탭바/패널/편집기 ===== */
[data-theme="dark"] .MonitoringDashboardModal_tabBar__Sulzk {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_tabItem__THfAv {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_tabActive__NPiHX {
  background: #264f78;
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .MonitoringDashboardModal_tabMain__o9NY0 {
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_tabActionBtn__bSNpv {
  color: var(--color-text-muted);
}

[data-theme="dark"] .MonitoringDashboardModal_tabActionBtn__bSNpv:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_panelHeader__tig-2 h3 {
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_panelEditBtn__HELeB {
  color: var(--color-text-muted);
}

[data-theme="dark"] .MonitoringDashboardModal_panelEditBtn__HELeB:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_panelToggleBtn__kMhdj {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_panelToggleBtn__kMhdj:hover {
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_panelToggleBtnOn__gNzT0 {
  color: #34d399;   /* 활성 — 다크에서도 녹색 톤 유지 */
}
[data-theme="dark"] .MonitoringDashboardModal_panelDisabledBody__tCExE {
  color: var(--color-text-muted);
  border-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_panelWaitingBody__TY\\+z- {
  color: var(--color-text-muted);
  border-color: rgba(251, 191, 36, 0.4);
  background: rgba(251, 191, 36, 0.08);
}
[data-theme="dark"] .MonitoringDashboardModal_panelWaitingBody__TY\\+z- small {
  color: #fbbf24;
}
[data-theme="dark"] .MonitoringDashboardModal_panelPublisherBadge__YzLUD {
  background: rgba(59, 130, 246, 0.18);
  border-color: rgba(59, 130, 246, 0.4);
  color: #93c5fd;
}
[data-theme="dark"] .MonitoringDashboardModal_panelDragHandle__nTtm7 {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_panelDragHandle__nTtm7:hover {
  color: var(--color-text);
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_slotCellDropActive__F\\+5q0 {
  background: rgba(59, 130, 246, 0.12);
  outline-color: #60a5fa;
}
[data-theme="dark"] .MonitoringDashboardModal_emptySlotDropActive__6mEyt {
  background: rgba(59, 130, 246, 0.15) !important;
  border-color: #60a5fa !important;
}

[data-theme="dark"] .MonitoringDashboardModal_addPanelTile__uY70f {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_emptyTab__bXeot {
  color: var(--color-text-muted);
}

[data-theme="dark"] .MonitoringDashboardModal_detachedNotice__M5dva {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-muted);
}

[data-theme="dark"] .MonitoringDashboardModal_btnSecondary__VZX2I {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_btnSecondary__VZX2I:hover {
  background: var(--color-hover);
}

[data-theme="dark"] .MonitoringDashboardModal_rotationOn__Oy1u3 {
  background: rgba(22, 163, 74, 0.2);
  border-color: #16a34a;
  color: #86efac;
}

[data-theme="dark"] .MonitoringDashboardModal_dwellLabel__kQA26 {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .MonitoringDashboardModal_panelError__X26Bk {
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
}

/* Dark mode */
@media (prefers-color-scheme: dark) {
  .MonitoringDashboardModal_modal__LDvh2 {
    background: #374151;
  }

  .MonitoringDashboardModal_header__f48Tr {
    border-bottom-color: #4b5563;
  }

  .MonitoringDashboardModal_header__f48Tr h2 {
    color: #f3f4f6;
  }

  .MonitoringDashboardModal_connSelect__GQVPX {
    background: #4b5563;
    border-color: #6b7280;
    color: #f3f4f6;
  }

  .MonitoringDashboardModal_connSelect__GQVPX:hover {
    border-color: #3b82f6;
  }

  .MonitoringDashboardModal_connSelect__GQVPX:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  .MonitoringDashboardModal_refreshBtn__5NDuB,
  .MonitoringDashboardModal_closeBtn__ygfjU {
    color: #9ca3af;
  }

  .MonitoringDashboardModal_refreshBtn__5NDuB:hover:not(:disabled),
  .MonitoringDashboardModal_closeBtn__ygfjU:hover {
    background: #4b5563;
    color: #f3f4f6;
  }

  .MonitoringDashboardModal_chartSection__PVQWu {
    background: #4b5563;
    border-color: #6b7280;
  }

  .MonitoringDashboardModal_chartSection__PVQWu h3 {
    color: #f3f4f6;
  }

  .MonitoringDashboardModal_footer__zHwI4 {
    border-top-color: #4b5563;
    background: #2d3748;
  }

  .MonitoringDashboardModal_autoRefreshControl__dSNhm {
    color: #e5e7eb;
  }

  .MonitoringDashboardModal_autoRefreshControl__dSNhm label {
    color: #e5e7eb;
  }

  .MonitoringDashboardModal_intervalSelect__KtBFH {
    background: #4b5563;
    border-color: #6b7280;
    color: #f3f4f6;
  }

  .MonitoringDashboardModal_timestamp__kXY8g {
    color: #9ca3af;
  }
}

/* Data theme attribute support */
[data-theme="dark"] .MonitoringDashboardModal_modal__LDvh2 {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_header__f48Tr {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_header__f48Tr h2 {
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_connSelect__GQVPX {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_connSelect__GQVPX:hover {
  border-color: var(--color-hover-border, #5a5a5a);
}

[data-theme="dark"] .MonitoringDashboardModal_connSelect__GQVPX:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .MonitoringDashboardModal_refreshBtn__5NDuB,
[data-theme="dark"] .MonitoringDashboardModal_closeBtn__ygfjU {
  color: var(--color-text-muted);
}

[data-theme="dark"] .MonitoringDashboardModal_refreshBtn__5NDuB:hover:not(:disabled),
[data-theme="dark"] .MonitoringDashboardModal_closeBtn__ygfjU:hover {
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_chartSection__PVQWu {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}

[data-theme="dark"] .MonitoringDashboardModal_chartSection__PVQWu h3 {
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_footer__zHwI4 {
  border-top-color: var(--color-border);
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .MonitoringDashboardModal_autoRefreshControl__dSNhm {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .MonitoringDashboardModal_autoRefreshControl__dSNhm label {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .MonitoringDashboardModal_intervalSelect__KtBFH {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .MonitoringDashboardModal_timestamp__kXY8g {
  color: var(--color-text-muted);
}

/* =================================================================== */
/* 전체화면 토글 (2026-04-24) — 모달을 브라우저/Electron 창 꽉 채움      */
/* =================================================================== */
.MonitoringDashboardModal_modalFullscreen__L247B {
  width: calc(100vw / var(--app-zoom, 1)) !important;
  height: calc(100vh / var(--app-zoom, 1)) !important;
  max-width: none !important;
  border-radius: 0 !important;
}

/* 전체화면(또는 분리 popup OS-fullscreen) 시 폰트 살짝 키워 가독성 ↑.
   recharts 는 inline style 로 font-size 박혀있어 !important 로 덮어씀. */
/* 카드/헤더 패딩을 줄여 차트 영역 최대화 (분리 popup OS-fullscreen 에서 특히 효과 큼) */
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_chartSection__PVQWu { padding: 10px 12px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelHeader__tig-2 { margin-bottom: 6px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_slotGrid__ximDU { gap: 10px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_collapsedStrip__rzfXC { margin-top: 8px; padding: 6px 8px; min-height: 36px; }
/* 패널 제목 — descendant 선택자로 panelHeader > panelTitleWrapper > h3 모두 매칭 */
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_chartSection__PVQWu h3 { font-size: 16px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelPublisherBadge__YzLUD { font-size: 11px; padding: 1px 8px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelPublisherBadgeValue__HKWwK { font-size: 11px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelDisabledBody__tCExE,
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelWaitingBody__TY\\+z- { font-size: 13px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelDisabledBody__tCExE small,
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelWaitingBody__TY\\+z- small { font-size: 12px; }
.MonitoringDashboardModal_modalFullscreen__L247B .MonitoringDashboardModal_panelError__X26Bk { font-size: 13px; padding: 8px 12px; }

/* recharts 내부 텍스트 — inline style 덮기 위해 !important.
   :global 로 CSS Module hashing 회피해 popup 에 복사된 CSS 에서도 동일하게 작동. */
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-text,
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-cartesian-axis-tick-value,
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-cartesian-axis-tick-value tspan { font-size: 13px !important; }
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-label,
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-label tspan { font-size: 14px !important; }
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-legend-wrapper,
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-default-legend,
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-legend-item-text { font-size: 14px !important; }
.MonitoringDashboardModal_modalFullscreen__L247B .recharts-default-tooltip { font-size: 13px !important; }
.MonitoringDashboardModal_fsBtn__dfbYQ {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MonitoringDashboardModal_fsBtn__dfbYQ:hover {
  color: #333;
}
[data-theme="dark"] .MonitoringDashboardModal_fsBtn__dfbYQ {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_fsBtn__dfbYQ:hover {
  color: var(--color-text);
}

/* =================================================================== */
/* 고정 슬롯 그리드 (1x1 / 1x2 / 2x1 / 2x2) — PanelSlotGrid 렌더             */
/* =================================================================== */
.MonitoringDashboardModal_slotGrid__ximDU {
  display: grid;
  gap: 16px;
  width: 100%;
  align-items: stretch;
  /* body 의 flex column 안에서 남은 공간을 채워, 셀 행이 1fr 로 화면에 맞게 확장됨 */
  flex: 1 1;
  min-height: 0;
}
/* \`1fr\` = \`minmax(auto, 1fr)\` 이라 row/column 의 auto min 이 셀 콘텐츠
   min-height(emptySlot 260px, panelDisabledBody 200px 등)으로 잡혀,
   popup 같은 좁은 컨테이너에서 grid 가 부모 flex 영역을 초과해 하단
   collapsedStrip 위로 겹쳐 보이는 문제 발생. minmax(0, 1fr) 로 바꿔
   row/column 이 자유롭게 줄어들 수 있게 한다 — 자식들은 이미 min-height: 0
   처리돼 있음. */
.MonitoringDashboardModal_slotGrid1x1__j22V3 { grid-template-columns: minmax(0, 1fr); grid-template-rows: minmax(0, 1fr); }
.MonitoringDashboardModal_slotGrid1x2__Eu7A6 { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: minmax(0, 1fr); }
.MonitoringDashboardModal_slotGrid2x1__vpair { grid-template-columns: minmax(0, 1fr); grid-template-rows: repeat(2, minmax(0, 1fr)); }
.MonitoringDashboardModal_slotGrid2x2__GGQbX { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); }

/* 비대칭 레이아웃 — 왼쪽에 세로로 긴 패널 + 오른쪽에 2분할 (3 슬롯) */
.MonitoringDashboardModal_slotGrid1L2R__NUQbW {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    "L TR"
    "L BR";
}
.MonitoringDashboardModal_slotGrid1L2R__NUQbW > :nth-child(1) { grid-area: L; }
.MonitoringDashboardModal_slotGrid1L2R__NUQbW > :nth-child(2) { grid-area: TR; }
.MonitoringDashboardModal_slotGrid1L2R__NUQbW > :nth-child(3) { grid-area: BR; }

/* 비대칭 레이아웃 — 왼쪽에 2분할 + 오른쪽에 세로로 긴 패널 (3 슬롯) */
.MonitoringDashboardModal_slotGrid2L1R__WBeLb {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    "TL R"
    "BL R";
}
.MonitoringDashboardModal_slotGrid2L1R__WBeLb > :nth-child(1) { grid-area: TL; }
.MonitoringDashboardModal_slotGrid2L1R__WBeLb > :nth-child(2) { grid-area: BL; }
.MonitoringDashboardModal_slotGrid2L1R__WBeLb > :nth-child(3) { grid-area: R; }

/* 빈 슬롯 플레이스홀더 — 클릭 시 PanelEditor 오픈 */
.MonitoringDashboardModal_emptySlot__Qt8mm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #fafafa;
  min-height: 260px;
  cursor: pointer;
  color: #6b7280;
  font-size: 13px;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}
.MonitoringDashboardModal_emptySlot__Qt8mm:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #f3f4ff;
}
.MonitoringDashboardModal_emptySlotIcon__zp07X {
  font-size: 28px;
  line-height: 1;
}
.MonitoringDashboardModal_emptySlotLabel__CHenm {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.MonitoringDashboardModal_emptySlotHint__UAHZo {
  font-size: 11px;
  color: #9ca3af;
  letter-spacing: 0.2px;
}
[data-theme="dark"] .MonitoringDashboardModal_emptySlotHint__UAHZo { color: var(--color-text-muted); }
[data-theme="dark"] .MonitoringDashboardModal_emptySlot__Qt8mm {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_emptySlot__Qt8mm:hover {
  border-color: var(--color-hover-border, #5a5a5a);
  color: var(--color-text);
  background: var(--color-hover);
}

/* 슬롯 초과 패널 안내 배너 */
.MonitoringDashboardModal_slotOverflowNotice__efTa6 {
  padding: 10px 14px;
  margin-top: 12px;
  font-size: 12px;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 6px;
  line-height: 1.5;
}
[data-theme="dark"] .MonitoringDashboardModal_slotOverflowNotice__efTa6 {
  color: #fbbf24;
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.3);
}

/* =================================================================== */
/* 설정 탭 (⚙ 설정) — 탭별 레이아웃 관리                                */
/* =================================================================== */
.MonitoringDashboardModal_settingsTab__gWal5 {
  padding: 4px 4px 20px;
}
.MonitoringDashboardModal_settingsTab__gWal5 h3 {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.MonitoringDashboardModal_settingsTab__gWal5 p {
  margin: 0 0 16px;
  font-size: 12px;
  color: #6b7280;
}
.MonitoringDashboardModal_settingsTable__dygzk {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.MonitoringDashboardModal_settingsTable__dygzk th {
  text-align: left;
  padding: 8px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  color: #374151;
}
.MonitoringDashboardModal_settingsTable__dygzk td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: middle;
}
.MonitoringDashboardModal_settingsRowDisabled__ZXYYx {
  opacity: 0.55;
}
.MonitoringDashboardModal_settingsRowDisabled__ZXYYx td {
  cursor: not-allowed;
}
.MonitoringDashboardModal_tabKindBadge__11FHG {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 10px;
  background: #e0e7ff;
  color: #3730a3;
  font-weight: 500;
}
.MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindBuiltin__4Iwgn { background: #dbeafe; color: #1e3a8a; }
.MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindCustom__ab2eG  { background: #fce7f3; color: #9d174d; }
.MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindUser__C\\+REy    { background: #dcfce7; color: #166534; }
.MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindOverview__4ggPi { background: #e5e7eb; color: #4b5563; }

/* 탭 버튼 내부의 인라인 아이콘 (텍스트 좌측 여백·중앙 정렬) */
.MonitoringDashboardModal_tabIcon__e1ZyH {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
  color: inherit;
  opacity: 0.85;
}
.MonitoringDashboardModal_tabIcon__e1ZyH > svg { flex-shrink: 0; }

/* 쿼리 템플릿 매니저 — 차트 타입별 필터 탭 */
.MonitoringDashboardModal_chartFilterTabs__mOHbT {
  display: flex;
  gap: 6px;
  margin: 8px 0 12px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 6px;
}
.MonitoringDashboardModal_chartFilterTab__aAHP0 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid transparent;
  background: transparent;
  color: #6b7280;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.12s, color 0.12s, background 0.12s;
}
.MonitoringDashboardModal_chartFilterTab__aAHP0:hover {
  color: #374151;
  background: #f3f4f6;
}
.MonitoringDashboardModal_chartFilterTabActive__Q2Ekt {
  color: #1d4ed8;
  background: #dbeafe;
  border-color: #93c5fd;
  font-weight: 600;
}
.MonitoringDashboardModal_chartFilterTabCount__bVmMJ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  background: #e5e7eb;
  color: #4b5563;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 600;
}
.MonitoringDashboardModal_chartFilterTabActive__Q2Ekt .MonitoringDashboardModal_chartFilterTabCount__bVmMJ {
  background: #1d4ed8;
  color: #fff;
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTabs__mOHbT {
  border-bottom-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTab__aAHP0 {
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTab__aAHP0:hover {
  color: var(--color-text);
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTabActive__Q2Ekt {
  color: #93c5fd;
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.3);
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTabCount__bVmMJ {
  background: var(--color-bg-secondary);
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTabActive__Q2Ekt .MonitoringDashboardModal_chartFilterTabCount__bVmMJ {
  background: #60a5fa;
  color: var(--color-bg);
}

/* 설정 탭 하단 액션 영역 */
.MonitoringDashboardModal_settingsActions__Ag2XO {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
}

/* 인라인 편집 그룹 (이름 변경 / 신규 탭 입력) */
.MonitoringDashboardModal_inlineEditGroup__OnRzZ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.MonitoringDashboardModal_inlineInput__UvTMo {
  padding: 5px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  min-width: 180px;
  outline: none;
  background: #fff;
  color: #111827;
}
.MonitoringDashboardModal_inlineInput__UvTMo:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

/* 작은 아이콘 버튼 (편집/저장/취소/삭제) */
.MonitoringDashboardModal_iconBtn__0gu04, .MonitoringDashboardModal_iconBtnConfirm__1Z-V3, .MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #6b7280;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  transition: border-color 0.12s, color 0.12s, background 0.12s;
}
.MonitoringDashboardModal_iconBtn__0gu04:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}
.MonitoringDashboardModal_iconBtnConfirm__1Z-V3 {
  background: #10b981;
  border-color: #10b981;
  color: #fff;
}
.MonitoringDashboardModal_iconBtnConfirm__1Z-V3:hover {
  background: #059669;
  border-color: #059669;
}
.MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2:hover {
  border-color: #ef4444;
  color: #ef4444;
}

/* 위험한 작업 확정 버튼 (인라인 2단계 삭제 확인) */
.MonitoringDashboardModal_iconBtnConfirmDanger__\\+7sZt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  height: 26px;
  min-width: 48px;
  border: 1px solid #ef4444;
  background: #ef4444;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: background 0.12s, border-color 0.12s;
}
.MonitoringDashboardModal_iconBtnConfirmDanger__\\+7sZt:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.MonitoringDashboardModal_rowActions__sgqqM {
  display: inline-flex;
  gap: 4px;
}

/* Overview 탭의 DataSource 선택 바 */
.MonitoringDashboardModal_overviewDsBar__P4Pm5 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
}
.MonitoringDashboardModal_overviewDsBar__P4Pm5 label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #374151;
}
.MonitoringDashboardModal_overviewWarn__cEFT4 {
  color: #92400e;
  font-size: 12px;
}
.MonitoringDashboardModal_overviewEmpty__9n3mg {
  padding: 40px 20px;
  text-align: center;
  color: #6b7280;
}
[data-theme="dark"] .MonitoringDashboardModal_overviewDsBar__P4Pm5 {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_overviewDsBar__P4Pm5 label { color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_overviewEmpty__9n3mg { color: var(--color-text-muted); }

/* DataSource "기본" 배지 (설정 탭의 DS 목록) */
.MonitoringDashboardModal_dsDefaultBadge__inWen {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  font-size: 10px;
  border-radius: 10px;
  background: #fef3c7;
  color: #92400e;
  font-weight: 600;
  margin-left: 6px;
}
[data-theme="dark"] .MonitoringDashboardModal_dsDefaultBadge__inWen {
  background: rgba(245, 158, 11, 0.2);
  color: #fbbf24;
}

/* 보이기/숨기기 토글 — 눈 아이콘 */
.MonitoringDashboardModal_visibilityToggle__eEWPB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #3b82f6;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  transition: border-color 0.12s, color 0.12s, background 0.12s;
}
.MonitoringDashboardModal_visibilityToggle__eEWPB:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}
.MonitoringDashboardModal_visibilityToggle__eEWPB.MonitoringDashboardModal_visibilityHidden__H-dxf {
  color: #9ca3af;
  background: #f3f4f6;
}
.MonitoringDashboardModal_visibilityToggle__eEWPB.MonitoringDashboardModal_visibilityHidden__H-dxf:hover {
  color: #6b7280;
  background: #e5e7eb;
}
[data-theme="dark"] .MonitoringDashboardModal_visibilityToggle__eEWPB {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: #60a5fa;
}
[data-theme="dark"] .MonitoringDashboardModal_visibilityToggle__eEWPB:hover {
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_visibilityToggle__eEWPB.MonitoringDashboardModal_visibilityHidden__H-dxf {
  color: var(--color-text-muted);
  background: var(--color-bg);
}

[data-theme="dark"] .MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindUser__C\\+REy { background: rgba(34, 197, 94, 0.2); color: #86efac; }
[data-theme="dark"] .MonitoringDashboardModal_inlineInput__UvTMo {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_iconBtn__0gu04, [data-theme="dark"] .MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2 {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-muted);
}
[data-theme="dark"] .MonitoringDashboardModal_iconBtn__0gu04:hover {
  color: var(--color-text);
  border-color: var(--color-hover-border, #5a5a5a); background: var(--color-hover);}
[data-theme="dark"] .MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2:hover {
  color: #f87171;
  border-color: #f87171;
}

[data-theme="dark"] .MonitoringDashboardModal_settingsTab__gWal5 h3 { color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_settingsTab__gWal5 p  { color: var(--color-text-muted); }
[data-theme="dark"] .MonitoringDashboardModal_settingsTable__dygzk th {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_settingsTable__dygzk td {
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_tabKindBadge__11FHG { background: rgba(99, 102, 241, 0.2); color: #a5b4fc; }
[data-theme="dark"] .MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindBuiltin__4Iwgn { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }
[data-theme="dark"] .MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindCustom__ab2eG  { background: rgba(236, 72, 153, 0.2); color: #f9a8d4; }
[data-theme="dark"] .MonitoringDashboardModal_tabKindBadge__11FHG.MonitoringDashboardModal_kindOverview__4ggPi { background: rgba(156, 163, 175, 0.2); color: #d1d5db; }

/* =================================================================== */
/* LayoutSelector — 4+1 (auto) 아이콘 라디오 그룹                        */
/* =================================================================== */
.MonitoringDashboardModal_layoutSelector__ySbzE {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}
.MonitoringDashboardModal_layoutOption__z319j {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  padding: 4px;
  transition: border-color 0.12s, background 0.12s;
}
.MonitoringDashboardModal_layoutOption__z319j:hover:not(:disabled) {
  border-color: #93c5fd;
  background: #eff6ff;
}
.MonitoringDashboardModal_layoutOptionActive__rmLTT {
  border-color: #3b82f6 !important;
  background: #dbeafe !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}
.MonitoringDashboardModal_layoutOption__z319j:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.MonitoringDashboardModal_layoutOptionAuto__TZUtG {
  width: auto;
  padding: 4px 10px;
  font-size: 12px;
  color: #374151;
}
.MonitoringDashboardModal_layoutIcon__1ZVeq {
  display: grid;
  gap: 2px;
  width: 22px;
  height: 18px;
}
.MonitoringDashboardModal_layoutIcon__1ZVeq span {
  background: #6b7280;
  border-radius: 1px;
  display: block;
}
.MonitoringDashboardModal_layoutOptionActive__rmLTT .MonitoringDashboardModal_layoutIcon__1ZVeq span {
  background: #1d4ed8;
}
[data-theme="dark"] .MonitoringDashboardModal_layoutOption__z319j {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .MonitoringDashboardModal_layoutOption__z319j:hover:not(:disabled) {
  border-color: var(--color-hover-border, #5a5a5a);
  background: var(--color-hover);
}
[data-theme="dark"] .MonitoringDashboardModal_layoutOptionActive__rmLTT {
  background: rgba(59, 130, 246, 0.2) !important;
}
[data-theme="dark"] .MonitoringDashboardModal_layoutOptionAuto__TZUtG {
  color: var(--color-text);
}
[data-theme="dark"] .MonitoringDashboardModal_layoutIcon__1ZVeq span { background: #9ca3af; }
[data-theme="dark"] .MonitoringDashboardModal_layoutOptionActive__rmLTT .MonitoringDashboardModal_layoutIcon__1ZVeq span { background: #60a5fa; }

/* ===== 최근 창(자원·세션·성능 분석·카탈로그)과 모양 맞춤 (2026-10-03) =====
   앞의 규칙을 지우지 않고 뒤에서 덮는다 — 분리 창(팝업)·전체 화면 규칙이 같은 클래스를 쓴다.
   - 탭은 둥근 리본(고른 것 = 파란 테두리·옅은 파랑 바탕·굵은 글자). 로테이션 체크·분리 버튼은 리본 안에 둔다
   - 글자·여백은 12px 계열로(다른 창들과 같은 밀도) */
.MonitoringDashboardModal_tabBar__Sulzk {
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border-bottom: 1px solid #e5e7eb;
}
.MonitoringDashboardModal_tabItem__THfAv {
  gap: 2px;
  padding: 1px 8px 1px 2px;
  border-radius: 999px;
  border-color: #d1d5db;
  background: #fff;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.MonitoringDashboardModal_tabItem__THfAv:hover { border-color: #3b82f6; }
.MonitoringDashboardModal_tabActive__NPiHX { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); }
.MonitoringDashboardModal_tabMain__o9NY0 { font-size: 12px; padding: 3px 6px; color: #4b5563; }
.MonitoringDashboardModal_tabActive__NPiHX .MonitoringDashboardModal_tabMain__o9NY0 { color: #1d4ed8; font-weight: 600; }
.MonitoringDashboardModal_tabActionBtn__bSNpv { border-radius: 999px; }
.MonitoringDashboardModal_header__f48Tr h2 { font-size: 14px; }
.MonitoringDashboardModal_headerControls__\\+mfLN { gap: 8px; }
.MonitoringDashboardModal_connSelect__GQVPX { padding: 3px 8px; font-size: 12px; border-radius: 4px; min-width: 0; }
.MonitoringDashboardModal_syncCheckLabel__oKpgM { font-size: 12px; }
.MonitoringDashboardModal_chartSection__PVQWu { padding: 10px 12px; }
.MonitoringDashboardModal_panelHeader__tig-2 { margin-bottom: 6px; }
.MonitoringDashboardModal_panelHeader__tig-2 h3 { font-size: 12px; }
.MonitoringDashboardModal_footer__zHwI4 { padding: 10px 16px; }
.MonitoringDashboardModal_autoRefreshControl__dSNhm { font-size: 12px; gap: 8px; }
.MonitoringDashboardModal_intervalSelect__KtBFH { padding: 3px 8px; font-size: 12px; }
.MonitoringDashboardModal_btnSecondary__VZX2I { font-size: 12px; }
[data-theme="dark"] .MonitoringDashboardModal_tabBar__Sulzk { background: transparent; border-bottom-color: var(--color-border); }
[data-theme="dark"] .MonitoringDashboardModal_tabItem__THfAv { background: var(--color-btn-bg); border-color: var(--color-btn-border); }
[data-theme="dark"] .MonitoringDashboardModal_tabActive__NPiHX { background: rgba(59, 130, 246, 0.18); border-color: var(--color-accent-fg); }
[data-theme="dark"] .MonitoringDashboardModal_tabMain__o9NY0 { color: var(--color-text-secondary); }
[data-theme="dark"] .MonitoringDashboardModal_tabActive__NPiHX .MonitoringDashboardModal_tabMain__o9NY0 { color: #93c5fd; }
@media (prefers-reduced-motion: reduce) { .MonitoringDashboardModal_tabItem__THfAv { transition: none; } }

/* 기본 탭 → 분석 창 바로가기(2026-10-03) */
.MonitoringDashboardModal_relatedBar__7hJhM { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin: 0 0 10px; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 6px; background: #f9fafb; font-size: 12px; animation: MonitoringDashboardModal_dashFadeIn__x8G\\+M 160ms ease-out; }
.MonitoringDashboardModal_relatedNote__3nLP6 { color: #6b7280; margin-right: 4px; }
.MonitoringDashboardModal_relatedBtn__Kn9ue { display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border: 1px solid #d1d5db; border-radius: 999px; background: #fff; color: #1d4ed8; font-size: 12px; cursor: pointer; transition: background-color 150ms ease, border-color 150ms ease; }
.MonitoringDashboardModal_relatedBtn__Kn9ue:hover { border-color: #3b82f6; background: rgba(59, 130, 246, 0.08); }
@keyframes MonitoringDashboardModal_dashFadeIn__x8G\\+M { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
[data-theme="dark"] .MonitoringDashboardModal_relatedBar__7hJhM { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .MonitoringDashboardModal_relatedNote__3nLP6 { color: var(--color-text-muted); }
[data-theme="dark"] .MonitoringDashboardModal_relatedBtn__Kn9ue { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: #93c5fd; }
@media (prefers-reduced-motion: reduce) { .MonitoringDashboardModal_relatedBar__7hJhM { animation: none; } .MonitoringDashboardModal_relatedBtn__Kn9ue { transition: none; } }

/* 구독한 대시보드 표시(2026-10-03) */
.MonitoringDashboardModal_subscribedBadge__-YY7q { display: inline-flex; align-items: center; gap: 3px; margin-left: 8px; padding: 0 7px; border-radius: 999px; background: #eff6ff; color: #1d4ed8; font-size: 10.5px; font-weight: 600; }
[data-theme="dark"] .MonitoringDashboardModal_subscribedBadge__-YY7q { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }

/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====
   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.
   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */
.MonitoringDashboardModal_body__u\\+tuT { padding: 12px 16px; gap: 12px; font-size: 12px; }
.MonitoringDashboardModal_btnPrimary__Uu36a, .MonitoringDashboardModal_btnSecondary__VZX2I {
  height: 30px; box-sizing: border-box; padding: 0 14px; border-radius: 6px;
  font-size: 13px; line-height: 1; gap: 6px;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.MonitoringDashboardModal_btnSecondary__VZX2I { background: #e5e7eb; border-color: #d1d5db; color: #374151; }
.MonitoringDashboardModal_btnSecondary__VZX2I:hover { background: #d1d5db; }
.MonitoringDashboardModal_btnPrimary__Uu36a > svg, .MonitoringDashboardModal_btnSecondary__VZX2I > svg { display: block; flex-shrink: 0; margin: 0 !important; }
.MonitoringDashboardModal_settingsTab__gWal5 { padding: 0 0 12px; }
.MonitoringDashboardModal_settingsTab__gWal5 h3 { font-size: 13px; }
.MonitoringDashboardModal_settingsTable__dygzk { font-size: 12px; }
.MonitoringDashboardModal_settingsTable__dygzk th { padding: 6px 8px; border-bottom: 2px solid #d0d5db; color: #333; white-space: nowrap; }
.MonitoringDashboardModal_settingsTable__dygzk td { padding: 5px 8px; border-bottom: 1px solid #eee; color: #374151; }
.MonitoringDashboardModal_tabKindBadge__11FHG { padding: 1px 8px; border-radius: 999px; font-size: 10.5px; }
.MonitoringDashboardModal_inlineInput__UvTMo { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }
.MonitoringDashboardModal_iconBtn__0gu04, .MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2 { transition: background-color 150ms ease, color 150ms ease; }
.MonitoringDashboardModal_chartFilterTabs__mOHbT { flex-wrap: wrap; border-bottom: none; padding-bottom: 0; margin: 4px 0 10px; }
.MonitoringDashboardModal_chartFilterTab__aAHP0 {
  padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 999px; background: #fff; color: #4b5563;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.MonitoringDashboardModal_chartFilterTab__aAHP0:hover { border-color: #3b82f6; }
.MonitoringDashboardModal_chartFilterTabActive__Q2Ekt { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }
[data-theme="dark"] .MonitoringDashboardModal_btnSecondary__VZX2I { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_btnSecondary__VZX2I:hover { background: var(--color-hover); }
[data-theme="dark"] .MonitoringDashboardModal_settingsTable__dygzk th { border-bottom-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_settingsTable__dygzk td { border-bottom-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTab__aAHP0 { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .MonitoringDashboardModal_chartFilterTabActive__Q2Ekt { border-color: var(--color-accent-fg); background: rgba(59, 130, 246, 0.18); color: #93c5fd; }
@media (prefers-reduced-motion: reduce) { .MonitoringDashboardModal_btnPrimary__Uu36a, .MonitoringDashboardModal_btnSecondary__VZX2I, .MonitoringDashboardModal_chartFilterTab__aAHP0, .MonitoringDashboardModal_iconBtn__0gu04, .MonitoringDashboardModal_iconBtnDanger__4\\+P\\+2 { transition: none; } }

/* 수집 미등록 안내 — 그래프가 왜 비었는지와 가는 길 */
.MonitoringDashboardModal_collectBanner__qY813 { display: flex; align-items: center; gap: 10px; margin: 0 0 10px; padding: 10px 14px; border-radius: 6px; background: #fffbeb; border: 1px solid #fcd34d; color: #92400e; font-size: 12.5px; animation: MonitoringDashboardModal_collect-banner-fade__gREUf 160ms ease-out; }
.MonitoringDashboardModal_collectBanner__qY813 span { flex: 1 1; }
@keyframes MonitoringDashboardModal_collect-banner-fade__gREUf { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
[data-theme="dark"] .MonitoringDashboardModal_collectBanner__qY813 { background: rgba(146, 64, 14, 0.25); border-color: #92400e; color: #fde68a; }
@media (prefers-reduced-motion: reduce) { .MonitoringDashboardModal_collectBanner__qY813 { animation: none; } }

/* ===== 한 화면에 — 스크롤 없는 대시보드(2026-10-18) =====
   순환·관제 화면은 한눈에 보여야 한다. 패널 탭의 본문은 스크롤하지 않고, 격자가 남은 높이를 꼭 채운다(행은 minmax(0, 1fr)).
   패널이 늘면 행이 늘어나는 대신 칸이 작아진다. 접힌 패널 줄은 한 줄 — 넘치는 카드는 감춘다(줄바꿈하면 길어진다) */
.MonitoringDashboardModal_bodyFit__4j7pO { overflow: hidden; }
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_panelGrid__OxzGj { overflow: hidden; grid-auto-rows: unset; }
/* 카드의 padding·border 가 높이 100% 에 **더해지면** 칸보다 커져 아래(범례)가 잘린다 — 고정 배치의 slotCell 과 같이 border-box */
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_panelGrid__OxzGj > * { min-height: 0; min-width: 0; box-sizing: border-box; }
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_panelGrid__OxzGj .MonitoringDashboardModal_chartSection__PVQWu,
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_panelDisabledBody__tCExE,
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_panelWaitingBody__TY\\+z-,
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_emptySlot__Qt8mm { min-height: 0; }
.MonitoringDashboardModal_bodyFit__4j7pO .MonitoringDashboardModal_collapsedStrip__rzfXC { flex-wrap: nowrap; overflow: hidden; }
/* 자동 배치의 「패널 추가」 줄 — 칸을 차지하지 않게 얇게(접힌 패널 줄 모양을 쓰면 44px + 여백으로 화면을 먹었다) */
.MonitoringDashboardModal_addBar__4F6oP { flex-shrink: 0; display: flex; align-items: center; justify-content: flex-start; margin-top: 8px; }

/* 순환 전환 효과의 그릇(2026-10-18) — 패널 격자·접힌 줄을 그대로 담는다(body 의 세로 배치·간격을 물려받는다).
   애니메이션은 화면(Web Animations)이 건다 — 동작 줄이기 설정이면 걸지 않는다 */
.MonitoringDashboardModal_slideStage__zegOX { position: relative; flex: 1 1; min-height: 0; overflow: hidden; gap: inherit; }
/* 층은 무대를 꽉 채운다 — 미리 그리는 층도 크기를 가져야 차트가 제 크기로 그려진다(visibility 로만 감춘다) */
.MonitoringDashboardModal_slideLayer__tncJ\\+ { position: absolute; inset: 0; display: flex; flex-direction: column; gap: inherit; backface-visibility: hidden; background: #fff; }
/* 층마다 창과 같은 바탕 — 없으면 새 화면의 패널 사이 틈으로 앞 화면이 비친다(화면 확인 2026-10-18) */
[data-theme="dark"] .MonitoringDashboardModal_slideLayer__tncJ\\+ { background: var(--color-bg-tertiary); }
.MonitoringDashboardModal_slideLayerActive__tWvrA { z-index: 2; }
.MonitoringDashboardModal_slideLayerLeaving__kDEXx { z-index: 1; pointer-events: none; }
.MonitoringDashboardModal_slideLayerPreload__d-NBY { z-index: 0; visibility: hidden; pointer-events: none; }

/* 설정 탭의 「순환」 칸 — 체크 · 순서 · ▲▼ (2026-10-18) */
.MonitoringDashboardModal_rotationCell__hJzti { display: flex; align-items: center; gap: 4px; white-space: nowrap; }
.MonitoringDashboardModal_rotationPos__AZpoL { min-width: 2.2em; font-size: 12px; font-variant-numeric: tabular-nums; color: var(--color-text-muted, #6b7280); }
.MonitoringDashboardModal_rotationCell__hJzti .MonitoringDashboardModal_iconBtn__0gu04:disabled { opacity: 0.35; cursor: default; }

/* 일시 구간(2026-10-28) — 「직접 지정」 을 고르면 머리줄에 시작·끝 입력이 선다 */
.MonitoringDashboardModal_rangeBox__pXa3V {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  animation: MonitoringDashboardModal_dash-range-fade__sje8A 150ms ease-out;
}
.MonitoringDashboardModal_rangeBox__pXa3V input[type="datetime-local"] {
  padding: 6px 6px;
  border: 1px solid var(--color-border, #d1d5db);
  border-radius: 6px;
  font-size: 12px;
  color: var(--color-text, #374151);
  background: var(--color-bg, #fff);
}
@keyframes MonitoringDashboardModal_dash-range-fade__sje8A { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_rangeBox__pXa3V { animation: none; }
}

/* 쿼리 템플릿 — 왼쪽 목록 · 오른쪽 내용(2026-10-28) */
.MonitoringDashboardModal_qtmSplit__RtQpr { display: flex; flex: 1 1; min-height: 0; gap: 10px; }
.MonitoringDashboardModal_qtmList__hQXYb { flex: 0 0 46%; min-width: 280px; overflow-y: auto; border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px; }
.MonitoringDashboardModal_qtmRow__8HI3w { cursor: pointer; transition: background-color 150ms ease; }
.MonitoringDashboardModal_qtmRow__8HI3w:hover { background: var(--color-hover, rgba(0, 0, 0, 0.04)); }
.MonitoringDashboardModal_qtmRowActive__noaX6, .MonitoringDashboardModal_qtmRowActive__noaX6:hover { background: color-mix(in srgb, #3b82f6 14%, transparent); }
.MonitoringDashboardModal_qtmDetail__60ywv { flex: 1 1; min-width: 0; overflow: auto; border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px; }
.MonitoringDashboardModal_qtmEmpty__fosme { padding: 24px; color: var(--color-text-muted, #6b7280); text-align: center; font-size: 13px; }
.MonitoringDashboardModal_qtmDetailBody__Q4eFM { padding: 12px 14px; display: flex; flex-direction: column; gap: 8px; animation: MonitoringDashboardModal_qtm-fade__CdA25 150ms ease-out; }
.MonitoringDashboardModal_qtmDetailHead__On8GZ { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 14px; }
.MonitoringDashboardModal_qtmDesc__ZxDYs { margin: 0; font-size: 12px; color: var(--color-text-secondary, #555); line-height: 1.5; }
.MonitoringDashboardModal_qtmFields__OfSG9 { display: flex; gap: 12px; font-size: 12px; color: var(--color-text-secondary, #555); }
.MonitoringDashboardModal_qtmSql__deI57 {
  margin: 0; padding: 10px 12px; font-family: var(--font-mono, Consolas, monospace); font-size: 12px; line-height: 1.5;
  background: var(--color-bg-secondary, #f8fafc); border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px;
  white-space: pre; overflow: auto; max-height: 420px; color: var(--color-text, #222);
}
.MonitoringDashboardModal_qtmActions__4QsFd { display: flex; gap: 6px; flex-wrap: wrap; }
@keyframes MonitoringDashboardModal_qtm-fade__CdA25 { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) {
  .MonitoringDashboardModal_qtmDetailBody__Q4eFM { animation: none; }
  .MonitoringDashboardModal_qtmRow__8HI3w { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/MonitoringDashboardModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,UAAU;EACV,iBAAiB,SAAS,uBAAuB;EACjD,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,wDAAwB,eAAe,EAAE;AACzC,sEAAsC,kCAAkC,EAAE;;AAE1E;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kEAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,kCAAkC;EAClC,SAAS;EACT;;gEAE8D;EAC9D,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB,IAAI,mCAAmC;EACxD,kBAAkB;EAClB,yDAAyD;AAC3D;AACA,yDAAyB,cAAc,EAAE,mBAAmB,EAAE;AAC9D,0DAA0B,gBAAgB,EAAE;;AAE5C,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,iEAAiE;EACjE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE;;+EAE6E;EAC7E,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;0DAG0D;AAC1D;;;EAGE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,iEAAiE;AACjE,sDAAsD;AACtD,iEAAiE;AACjE;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;AAClE;AACA;EACE,+CAA+C;EAC/C,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uDAAuD;AACzD;AACA;EACE,qBAAqB;AACvB;AACA,yDAAyB,aAAa,EAAE;AACxC,yDAAyB,aAAa,EAAE,oBAAoB,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA,iEAAiC,cAAc,EAAE,mBAAmB,EAAE;AACtE,kEAAkC,gBAAgB,EAAE;;AAEpD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gEAAgE;AAClE;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE;qDACmB,gBAAgB,EAAE;AACvC;;AAEA;EACE;8CACY,gBAAgB,EAAE;AAChC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;wDACwD;AACxD;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yDAAyD;AAC3D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAO,WAAW,mCAAmC;EACrD,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;EACxC,yEAAyC;AAC3C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAO,WAAW,gBAAgB;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,yEAAyC;AAC3C;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kFAAkF;AACpF;AACA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE;yDACuB,gBAAgB,EAAE;EACzC;uDACoB,eAAe,EAAE;AACvC;;AAEA,iEAAiE;AACjE,kDAAkD;AAClD,iEAAiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,uEAAuC;AACzC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sEAAsC;AACxC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kFAAkF;AACpF;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA,2DAA2B,aAAa,EAAE,mBAAmB,EAAE;AAC/D;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA,oEAAoC,wBAAwB,EAAE;AAC9D;EACE,oCAAoC;EACpC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,gDAAgD;EAChD,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE;kDACgB,eAAe,EAAE;EACjC,kDAAkB,gBAAgB,EAAE;AACtC;;AAEA,iEAAiE;AACjE,4DAA4D;AAC5D,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,sCAAsC;EACtC,QAAQ;AACV;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,yEAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,yEAAyC;AAC3C;AACA,sEAAsC,8BAA8B,EAAE;AACtE;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE;iDACe,eAAe,EAAE;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc,IAAI,uBAAuB;AAC3C;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wEAAwE;AACxE,yDAAyD;AACzD,wEAAwE;AACxE;EACE,kDAAkD;EAClD,mDAAmD;EACnD,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;+DAC+D;AAC/D,+DAA+D;AAC/D,iGAAiC,kBAAkB,EAAE;AACrD,gGAAgC,kBAAkB,EAAE;AACpD,6FAA6B,SAAS,EAAE;AACxC,mGAAmC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxF,uEAAuE;AACvE,oGAAoC,eAAe,EAAE;AACrD,wGAAwC,eAAe,EAAE,gBAAgB,EAAE;AAC3E,6GAA6C,eAAe,EAAE;AAC9D;sGACqC,eAAe,EAAE;AACtD;4GAC2C,eAAe,EAAE;AAC5D,+FAA+B,eAAe,EAAE,iBAAiB,EAAE;;AAEnE;kEACkE;AAClE;;6FAEsE,0BAA0B,EAAE;AAClG;yEACkD,0BAA0B,EAAE;AAC9E;;8EAEuD,0BAA0B,EAAE;AACnF,6EAAsD,0BAA0B,EAAE;AAClF;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE,qEAAqE;AACrE,wEAAwE;AACxE;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,4DAA4D;EAC5D,SAAO;EACP,aAAa;AACf;AACA;;;;;YAKY;AACZ,+CAAe,qCAAqC,EAAE,kCAAkC,EAAE;AAC1F,+CAAe,gDAAgD,EAAE,kCAAkC,EAAE;AACrG,+CAAe,qCAAqC,EAAE,6CAA6C,EAAE;AACrG,+CAAe,gDAAgD,EAAE,6CAA6C,EAAE;;AAEhH,8CAA8C;AAC9C;EACE,oDAAoD;EACpD,iDAAiD;EACjD;;UAEQ;AACV;AACA,gEAAgC,YAAY,EAAE;AAC9C,gEAAgC,aAAa,EAAE;AAC/C,gEAAgC,aAAa,EAAE;;AAE/C,8CAA8C;AAC9C;EACE,oDAAoD;EACpD,iDAAiD;EACjD;;UAEQ;AACV;AACA,gEAAgC,aAAa,EAAE;AAC/C,gEAAgC,aAAa,EAAE;AAC/C,gEAAgC,YAAY,EAAE;;AAE9C,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA,qEAAqC,8BAA8B,EAAE;AACrE;EACE,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,gDAAgD;EAChD,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA,wEAAwE;AACxE,4DAA4D;AAC5D,wEAAwE;AACxE;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,4FAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4FAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,6FAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,6FAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;AACA,iDAAiB,cAAc,EAAE;;AAEjC,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,6DAA6D;AAC/D;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA,2EAA2C,wBAAwB,EAAE;AACrE,qEAAqC,8BAA8B,EAAE;;AAErE,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,6DAA6D;AAC/D;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,8GAA6C,kCAAkC,EAAE,cAAc,EAAE;AACjG;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,gDAAgD,EAAE,8BAA8B,CAAC;AACnF;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,sEAAsC,wBAAwB,EAAE;AAChE,sEAAsC,8BAA8B,EAAE;AACtE;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;AACA,oEAAoC,mCAAmC,EAAE,cAAc,EAAE;AACzF,gHAAgD,mCAAmC,EAAE,cAAc,EAAE;AACrG,gHAAgD,mCAAmC,EAAE,cAAc,EAAE;AACrG,iHAAiD,oCAAoC,EAAE,cAAc,EAAE;;AAEvG,wEAAwE;AACxE,kEAAkE;AAClE,wEAAwE;AACxE;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,wBAAwB;AAC1B;AACA,uEAAuC,mBAAmB,EAAE;AAC5D,2HAA2D,mBAAmB,EAAE;;AAEhF;;;oCAGoC;AACpC;EACE,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gEAAgE;AAClE;AACA,iDAAiB,qBAAqB,EAAE;AACxC,6CAAa,qBAAqB,EAAE,mCAAmC,EAAE;AACzE,2CAAW,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9D,sFAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD,gDAAgB,oBAAoB,EAAE;AACtC,6CAAa,eAAe,EAAE;AAC9B,mDAAkB,QAAQ,EAAE;AAC5B,8CAAc,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,YAAY,EAAE;AACnF,kDAAkB,eAAe,EAAE;AACnC,gDAAgB,kBAAkB,EAAE;AACpC,+CAAe,kBAAkB,EAAE;AACnC,kDAAkB,eAAe,EAAE;AACnC,0CAAU,kBAAkB,EAAE;AAC9B,sDAAsB,eAAe,EAAE,QAAQ,EAAE;AACjD,kDAAkB,gBAAgB,EAAE,eAAe,EAAE;AACrD,gDAAgB,eAAe,EAAE;AACjC,8DAA8B,uBAAuB,EAAE,wCAAwC,EAAE;AACjG,+DAA+B,+BAA+B,EAAE,qCAAqC,EAAE;AACvG,iEAAiC,oCAAoC,EAAE,oCAAoC,EAAE;AAC7G,+DAA+B,kCAAkC,EAAE;AACnE,0GAA0C,cAAc,EAAE;AAC1D,0CAA0C,2CAAW,gBAAgB,EAAE,EAAE;;AAEzE,iCAAiC;AACjC,8CAAc,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE,qEAAoC,EAAE;AAC7O,+CAAe,cAAc,EAAE,iBAAiB,EAAE;AAClD,8CAAc,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,gEAAgE,EAAE;AAC7Q,oDAAoB,qBAAqB,EAAE,oCAAoC,EAAE;AACjF,yDAAwB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAC9G,kEAAkC,qCAAqC,EAAE,iCAAiC,EAAE;AAC5G,mEAAmC,8BAA8B,EAAE;AACnE,kEAAkC,+BAA+B,EAAE,qCAAqC,EAAE,cAAc,EAAE;AAC1H,0CAA0C,8CAAc,eAAe,EAAE,EAAE,8CAAc,gBAAgB,EAAE,EAAE;;AAE7G,4BAA4B;AAC5B,mDAAmB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1M,uEAAuC,oCAAoC,EAAE,cAAc,EAAE;;AAE7F;;sEAEsE;AACtE,yCAAQ,kBAAkB,EAAE,SAAS,EAAE,eAAe,EAAE;AACxD;EACE,YAAY,EAAE,sBAAsB,EAAE,eAAe,EAAE,kBAAkB;EACzE,eAAe,EAAE,cAAc,EAAE,QAAQ;EACzC,kFAAkF;AACpF;AACA,gDAAgB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC5E,sDAAsB,mBAAmB,EAAE;AAC3C,yGAAyC,cAAc,EAAE,cAAc,EAAE,oBAAoB,EAAE;AAC/F,+CAAe,iBAAiB,EAAE;AAClC,kDAAkB,eAAe,EAAE;AACnC,iDAAiB,eAAe,EAAE;AAClC,oDAAoB,gBAAgB,EAAE,gCAAgC,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC1G,oDAAoB,gBAAgB,EAAE,6BAA6B,EAAE,cAAc,EAAE;AACrF,gDAAgB,gBAAgB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;AAC3E,+CAAe,YAAY,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7G,6FAA2B,yDAAyD,EAAE;AACtF,mDAAmB,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAChG;EACE,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,cAAc;EACpG,kFAAkF;AACpF;AACA,wDAAwB,qBAAqB,EAAE;AAC/C,wDAAwB,qBAAqB,EAAE,mCAAmC,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtH,oEAAoC,+BAA+B,EAAE,qCAAqC,EAAE,wBAAwB,EAAE;AACtI,0EAA0C,8BAA8B,EAAE;AAC1E,wEAAwC,wCAAwC,EAAE,wBAAwB,EAAE;AAC5G,wEAAwC,wCAAwC,EAAE,wBAAwB,EAAE;AAC5G,sEAAsC,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AAClJ,4EAA4C,oCAAoC,EAAE,oCAAoC,EAAE,cAAc,EAAE;AACxI,0CAA0C,0OAAwE,gBAAgB,EAAE,EAAE;;AAEtI,kCAAkC;AAClC,iDAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE,iBAAiB,EAAE,6EAA6C,EAAE;AAC5P,sDAAsB,SAAO,EAAE;AAC/B,iEAAiC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACvH,qEAA8C,mCAAmC,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1H,0CAA0C,iDAAiB,eAAe,EAAE,EAAE;;AAE9E;;sEAEsE;AACtE,2CAAW,gBAAgB,EAAE;AAC7B,sFAAsB,gBAAgB,EAAE,qBAAqB,EAAE;AAC/D,iGAAiG;AACjG,0FAA0B,aAAa,EAAE,YAAY,EAAE,sBAAsB,EAAE;AAC/E;;;sFAGsB,aAAa,EAAE;AACrC,2FAA2B,iBAAiB,EAAE,gBAAgB,EAAE;AAChE,yEAAyE;AACzE,0CAAU,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,eAAe,EAAE;;AAE5G;uDACuD;AACvD,8CAAc,kBAAkB,EAAE,SAAO,EAAE,aAAa,EAAE,gBAAgB,EAAE,YAAY,EAAE;AAC1F,uEAAuE;AACvE,+CAAc,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAChJ,mEAAmE;AACnE,mEAAkC,oCAAoC,EAAE;AACxE,oDAAoB,UAAU,EAAE;AAChC,qDAAqB,UAAU,EAAE,oBAAoB,EAAE;AACvD,qDAAqB,UAAU,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;;AAE3E,6CAA6C;AAC7C,gDAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACnF,+CAAe,gBAAgB,EAAE,eAAe,EAAE,kCAAkC,EAAE,uCAAuC,EAAE;AAC/H,kGAAkC,aAAa,EAAE,eAAe,EAAE;;AAElE,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yEAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,iCAAiC;AACnC;AACA,6DAA6B,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAC5H;EACE,4CAAY,eAAe,EAAE;AAC/B;;AAEA,wCAAwC;AACxC,4CAAY,aAAa,EAAE,SAAO,EAAE,aAAa,EAAE,SAAS,EAAE;AAC9D,2CAAW,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,8CAA8C,EAAE,kBAAkB,EAAE;AAClI,0CAAU,eAAe,EAAE,uCAAuC,EAAE;AACpE,gDAAgB,mDAAmD,EAAE;AACrE,qGAAqC,wDAAwD,EAAE;AAC/F,6CAAa,SAAO,EAAE,YAAY,EAAE,cAAc,EAAE,8CAA8C,EAAE,kBAAkB,EAAE;AACxH,4CAAY,aAAa,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACzG,iDAAiB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kEAAkC,EAAE;AAC1H,iDAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AACjG,2CAAW,SAAS,EAAE,eAAe,EAAE,wCAAwC,EAAE,gBAAgB,EAAE;AACnG,6CAAa,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,wCAAwC,EAAE;AAClG;EACE,SAAS,EAAE,kBAAkB,EAAE,kDAAkD,EAAE,eAAe,EAAE,gBAAgB;EACpH,8CAA8C,EAAE,8CAA8C,EAAE,kBAAkB;EAClH,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,8BAA8B;AACrF;AACA,8CAAc,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACxD,sDAAsB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACrH;EACE,iDAAiB,eAAe,EAAE;EAClC,0CAAU,gBAAgB,EAAE;AAC9B","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  width: 90%;\n  max-width: 1400px;        /* CriteriaModal 과 통일 */\n  height: calc(80vh / var(--app-zoom, 1));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n.header h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  flex: 1;\n}\n\n.headerControls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.connSelect {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #374151;\n  background: white;\n  cursor: pointer;\n  min-width: 150px;\n}\n\n/* 헤더의 시간축 동기화 체크박스 — connSelect 옆 inline. */\n.syncCheckLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  padding: 0 4px;\n  white-space: nowrap;\n  user-select: none;\n}\n.syncCheckLabel input { cursor: pointer; }\n[data-theme=\"dark\"] .syncCheckLabel { color: var(--color-text-secondary); }\n\n.connSelect:hover {\n  border-color: #3b82f6;\n}\n\n.connSelect:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.refreshBtn,\n.closeBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeBtn {\n  font-size: 18px;\n}\n\n.refreshBtn:hover:not(:disabled),\n.closeBtn:hover {\n  color: #333;\n}\n\n.refreshBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.refreshBtn:disabled svg {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.metricsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.chartsContainer {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.chartSection {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  /* 자식이 남은 공간을 채워 차트가 셀 크기에 맞춰 확장되도록 flex column */\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n}\n\n/* 차트 또는 placeholder 가 차지하는 영역 — 헤더 제외한 나머지 공간 모두 사용 */\n.panelChartWrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* `.chartSection h3` 은 직속 자식에만 적용 — 손자 h3(`.panelHeader h3`)의\n   font-size: 14px 와 동일 specificity 였던 게 source order 의존이라\n   CSS Module/HMR 시 가끔 16px 가 이기는 경우가 있어 직속(`>`) 으로 한정. */\n.chartSection > h3 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  color: #1f2937;\n}\n\n.noData {\n  height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n  gap: 16px;\n}\n\n.autoRefreshControl {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: #374151;\n}\n\n.autoRefreshControl label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.autoRefreshControl input {\n  cursor: pointer;\n}\n\n.intervalSelect {\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.timestamp {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n/* ===== 탭 바 ===== */\n.tabBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 6px 12px;\n  background: #f3f4f6;\n  border-bottom: 1px solid #e5e7eb;\n  overflow-x: auto;\n}\n\n.tabItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px 2px 2px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n}\n\n.tabActive {\n  border-color: #3b82f6;\n  background: #dbeafe;\n}\n\n.tabMain {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 13px;\n  color: #374151;\n  padding: 4px 8px;\n  /* 아이콘(span) + 텍스트 노드 수직 중앙 정렬 — baseline 어긋남 방지 */\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n}\n\n.tabMain:hover {\n  color: #1f2937;\n}\n\n.tabRotationLabel {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.tabRotationLabel input {\n  cursor: pointer;\n}\n\n.tabActionBtn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 3px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 3px;\n}\n\n.tabActionBtn:hover {\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n/* ===== 패널 그리드 ===== */\n.panelGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n  grid-auto-rows: minmax(350px, 1fr);\n  gap: 16px;\n  /* flex 부모(body / 분리 popup wrapper) 안에서 남은 세로 공간 채우도록.\n     grid-auto-rows 의 minmax(350px) 가 컨테이너 보다 큰 경우 collapsedStrip 영역으로\n     overflow 되어 시각적 겹침이 보일 수 있어 overflow-y: auto 로 내부 스크롤 처리. */\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.panelHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 10px 0;\n  flex-shrink: 0;\n}\n\n.panelHeader h3 {\n  margin: 0;\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n/* 제목 + publisher 배지를 묶은 영역 — 정렬은 inline justifyContent 로 결정 */\n.panelTitleWrapper {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* 드래그 핸들 — 카드 헤더 좌측. 마우스 올리면 진하게 */\n.panelDragHandle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  cursor: grab;\n  padding: 2px 4px;\n  margin-right: 8px;   /* 제목과 시각적 간격 — 핸들과 텍스트 붙어보이지 않도록 */\n  border-radius: 3px;\n  transition: color 160ms ease, background-color 160ms ease;\n}\n.panelDragHandle:hover { color: #374151; background: #e5e7eb; }\n.panelDragHandle:active { cursor: grabbing; }\n\n/* 드래그 중 카드 — 반투명으로 피드백 */\n.chartSectionDragging {\n  opacity: 0.45;\n}\n\n/* 슬롯 셀 래퍼 — drop zone 컨테이너 (flex 자식이라 grid cell 자리 그대로) */\n.slotCell {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  transition: outline-color 160ms ease, background-color 160ms ease;\n  outline: 2px solid transparent;\n  outline-offset: -2px;\n  border-radius: 8px;\n}\n.slotCellDropActive {\n  outline-color: #3b82f6;\n  background: rgba(59, 130, 246, 0.06);\n}\n.slotCell > * {\n  /* slotCell(flex-column) 안에서 자식이 남은 공간을 채우되,\n     padding/border 가 높이에 포함되도록 border-box — 안 그러면 content-box 기본값이라\n     chartSection 의 padding(16px) / emptySlot 의 border(2px) 가 더해져 부모 셀 밖으로 넘침 */\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* 슬롯 그리드 안의 placeholder/emptySlot 들은 자체 min-height (260/200px) 를\n   가지고 있어, popup 처럼 좁은 컨테이너에서 row 보다 큰 콘텐츠가 되어\n   인접 셀 또는 하단 strip 으로 시각적 overflow 발생.\n   slotCell 컨텍스트 에서는 min-height 를 풀어 row 크기에 맞춰 줄어들게 한다. */\n.slotCell .emptySlot,\n.slotCell .panelDisabledBody,\n.slotCell .panelWaitingBody {\n  min-height: 0;\n}\n\n/* 빈 슬롯이 drop target 일 때 강조 */\n.emptySlotDropActive {\n  border-color: #3b82f6 !important;\n  background: rgba(59, 130, 246, 0.08) !important;\n}\n\n/* ============================================================ */\n/* 접기(collapsed) 패널 strip — 그리드 아래 고정 영역             */\n/* ============================================================ */\n.collapsedStrip {\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  margin-top: 12px;\n  background: #f9fafb;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  min-height: 44px;\n  transition: background-color 160ms ease, border-color 160ms ease;\n}\n.collapsedStripDropActive {\n  background: rgba(59, 130, 246, 0.08) !important;\n  border-color: #3b82f6 !important;\n}\n.collapsedStripHint {\n  font-size: 12px;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n/* 접기 카드 — 한 줄짜리 작은 칩 형태 */\n.collapsedCard {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #1f2937;\n  max-width: 320px;\n  transition: opacity 160ms ease, border-color 160ms ease;\n}\n.collapsedCard:hover {\n  border-color: #9ca3af;\n}\n.collapsedCardDragging { opacity: 0.45; }\n.collapsedCardDisabled { opacity: 0.65; border-style: dashed; }\n\n.collapsedCardDragHandle {\n  display: inline-flex;\n  align-items: center;\n  color: #9ca3af;\n  cursor: grab;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.collapsedCardDragHandle:hover { color: #374151; background: #e5e7eb; }\n.collapsedCardDragHandle:active { cursor: grabbing; }\n\n.collapsedCardTitle {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n}\n\n/* + 패널 추가 버튼 (strip 좌측 고정) */\n.collapsedAddBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  background: #3b82f6;\n  border: 1px solid #3b82f6;\n  border-radius: 4px;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background-color 160ms ease, border-color 160ms ease;\n}\n.collapsedAddBtn:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n/* 다크 모드 */\n[data-theme=\"dark\"] .collapsedStrip {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .collapsedStripHint {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .collapsedCard {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .collapsedCard:hover {\n  border-color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .collapsedCardDragHandle {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .collapsedCardDragHandle:hover {\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsedCard,\n  .collapsedAddBtn { transition: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .panelDragHandle,\n  .slotCell { transition: none; }\n}\n\n.panelEditBtn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 4px;\n  border-radius: 3px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.panelEditBtn:hover {\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n/* 패널 활성/비활성 토글 버튼 — 편집 아이콘 옆 위치.\n   색상 부드러운 전환 (UI Conventions: 150~180ms ease, 색상 한정). */\n.panelToggleBtn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #9ca3af;\n  padding: 4px;\n  border-radius: 3px;\n  display: inline-flex;\n  align-items: center;\n  margin-right: 2px;\n  transition: color 160ms ease, background-color 160ms ease;\n}\n.panelToggleBtn:hover {\n  background: #e5e7eb;\n}\n.panelToggleBtnOn {\n  color: #10b981;\n}\n\n/* 비활성 카드 — 살짝 디밍 + 점선 테두리로 시각 구분 */\n.chartSectionDisabled {\n  opacity: 0.7;\n  border-style: dashed;\n}\n\n/* 비활성 패널 자리 표시 — 차트 자리에 안내 문구 */\n.panelDisabledBody {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 28px 12px;\n  color: #9ca3af;\n  font-size: 12px;\n  min-height: 200px;\n  flex: 1;          /* 카드 셀이 커지면 placeholder 도 같이 늘어남 */\n  border: 1px dashed #e5e7eb;\n  border-radius: 6px;\n  /* fade-in (UI Conventions: 120~200ms) */\n  animation: panelToggleFade 160ms ease-out;\n}\n@keyframes panelToggleFade {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* 변수 대기 placeholder — 다른 패널 클릭 기다리는 중 */\n.panelWaitingBody {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 28px 12px;\n  color: #6b7280;\n  font-size: 12px;\n  min-height: 200px;\n  flex: 1;          /* 카드 셀에 맞춰 확장 */\n  border: 1px dashed #fbbf24;\n  background: #fffbeb;\n  border-radius: 6px;\n  animation: panelToggleFade 160ms ease-out;\n}\n.panelWaitingBody small {\n  color: #92400e;\n  font-size: 11px;\n}\n\n/* publisher 패널 헤더 배지 — 클릭 시 :var 발행 시각 힌트 */\n.panelPublisherBadge {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 1px 6px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 3px;\n  color: #1e40af;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: var(--font-mono);\n  white-space: nowrap;\n  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;\n}\n/* 현재 발행값 부분 — 약간 더 진하게 강조 */\n.panelPublisherBadgeValue {\n  margin-left: 2px;\n  font-weight: 700;\n  color: #1e3a8a;\n}\n[data-theme=\"dark\"] .panelPublisherBadgeValue {\n  color: #dbeafe;\n}\n\n/* OS-level reduced motion 선호 시 무력화 */\n@media (prefers-reduced-motion: reduce) {\n  .panelToggleBtn,\n  .panelPublisherBadge { transition: none; }\n  .panelDisabledBody,\n  .panelWaitingBody { animation: none; }\n}\n\n/* ============================================================ */\n/* SQL 보기 모달 — 패널 헤더의 SQL 아이콘 클릭 시 표시            */\n/* ============================================================ */\n.sqlViewOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* fade-in (UI Conventions: 120~200ms ease-out) */\n  animation: sqlViewFadeIn 160ms ease-out;\n}\n@keyframes sqlViewFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n.sqlViewModal {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  width: 90%;\n  max-width: 880px;\n  max-height: calc(80vh / var(--app-zoom, 1));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  /* slight slide-down */\n  animation: sqlViewSlide 160ms ease-out;\n}\n@keyframes sqlViewSlide {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.sqlViewHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n}\n.sqlViewTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  margin-right: 8px;\n}\n.sqlViewActions {\n  display: inline-flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.sqlViewIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;\n}\n.sqlViewIconBtn:hover:not(:disabled) {\n  border-color: #3b82f6;\n  color: #2563eb;\n  background: #eff6ff;\n}\n.sqlViewIconBtn:disabled { opacity: 0.45; cursor: not-allowed; }\n.sqlViewSubheader {\n  padding: 6px 14px;\n  font-size: 11px;\n  color: #6b7280;\n  background: #fefce8;\n  border-bottom: 1px solid #fde68a;\n}\n.sqlViewSubheader code {\n  background: #fff7d6;\n  padding: 0 4px;\n  border-radius: 3px;\n  font-size: 11px;\n}\n.sqlViewBody {\n  margin: 0;\n  padding: 12px 14px;\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #1f2937;\n  white-space: pre;\n  tab-size: 2;\n}\n[data-theme=\"dark\"] .sqlViewModal {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .sqlViewHeader {\n  background: var(--color-bg-secondary);\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .sqlViewTitle { color: var(--color-text); }\n[data-theme=\"dark\"] .sqlViewIconBtn {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .sqlViewIconBtn:hover:not(:disabled) {\n  border-color: var(--color-hover-border, #5a5a5a);\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .sqlViewSubheader {\n  background: rgba(245, 158, 11, 0.12);\n  border-bottom-color: rgba(245, 158, 11, 0.3);\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .sqlViewSubheader code {\n  background: rgba(245, 158, 11, 0.18);\n  color: #fde68a;\n}\n[data-theme=\"dark\"] .sqlViewBody {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n@media (prefers-reduced-motion: reduce) {\n  .sqlViewOverlay,\n  .sqlViewModal { animation: none; }\n  .sqlViewIconBtn { transition: none; }\n}\n\n/* ============================================================ */\n/* 병합 차트 (chartType='merged') — sub-panel 세로 stack         */\n/* ============================================================ */\n.mergedStack {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  /* sub-panel 사이 시각적 구분 — 가벼운 divider */\n  gap: 4px;\n}\n.mergedItem {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  /* fade-in (UI Conventions: 120~200ms ease-out) */\n  animation: panelToggleFade 160ms ease-out;\n}\n.mergedSubTitle {\n  font-size: 11px;\n  font-weight: 500;\n  color: #6b7280;\n  padding: 2px 4px;\n  margin-bottom: 2px;\n  flex-shrink: 0;\n  /* 긴 제목 truncation — sub-panel 카드는 좁을 수 있음 */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mergedEmpty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  color: #9ca3af;\n  font-size: 12px;\n  border: 1px dashed #e5e7eb;\n  border-radius: 6px;\n  animation: panelToggleFade 160ms ease-out;\n}\n[data-theme=\"dark\"] .mergedSubTitle { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .mergedEmpty {\n  color: var(--color-text-muted);\n  border-color: var(--color-border);\n}\n@media (prefers-reduced-motion: reduce) {\n  .mergedItem,\n  .mergedEmpty { animation: none; }\n}\n\n.panelError {\n  background: #fee2e2;\n  color: #991b1b;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-bottom: 8px;\n  word-break: break-all;\n}\n\n.addPanelTile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.emptyTab {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n}\n\n.emptyTab p {\n  margin-bottom: 16px;\n}\n\n/* ===== 분리 안내 ===== */\n.detachedNotice {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6b7280;\n  font-size: 14px;\n  background: #fafafa;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n}\n\n.detachedNotice p {\n  margin-bottom: 16px;\n}\n\n/* ===== 공통 버튼 ===== */\n.btnPrimary,\n.btnSecondary {\n  padding: 6px 14px;\n  border-radius: 5px;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.btnPrimary {\n  background: #3b82f6;\n  color: white;\n  border: 1px solid #2563eb;\n}\n\n.btnPrimary:hover {\n  background: #2563eb;\n}\n\n.btnSecondary {\n  background: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btnSecondary:hover {\n  background: #f3f4f6;\n}\n\n.rotationOn {\n  background: #dcfce7;\n  border-color: #16a34a;\n  color: #166534;\n}\n\n.rotationControl {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dwellLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* ===== 다크모드 — 탭바/패널/편집기 ===== */\n[data-theme=\"dark\"] .tabBar {\n  background: var(--color-bg-secondary);\n  border-bottom-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .tabItem {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .tabActive {\n  background: #264f78;\n  border-color: var(--color-accent-fg);\n}\n\n[data-theme=\"dark\"] .tabMain {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .tabActionBtn {\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .tabActionBtn:hover {\n  background: var(--color-hover);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panelHeader h3 {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panelEditBtn {\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .panelEditBtn:hover {\n  background: var(--color-hover);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .panelToggleBtn {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panelToggleBtn:hover {\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .panelToggleBtnOn {\n  color: #34d399;   /* 활성 — 다크에서도 녹색 톤 유지 */\n}\n[data-theme=\"dark\"] .panelDisabledBody {\n  color: var(--color-text-muted);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .panelWaitingBody {\n  color: var(--color-text-muted);\n  border-color: rgba(251, 191, 36, 0.4);\n  background: rgba(251, 191, 36, 0.08);\n}\n[data-theme=\"dark\"] .panelWaitingBody small {\n  color: #fbbf24;\n}\n[data-theme=\"dark\"] .panelPublisherBadge {\n  background: rgba(59, 130, 246, 0.18);\n  border-color: rgba(59, 130, 246, 0.4);\n  color: #93c5fd;\n}\n[data-theme=\"dark\"] .panelDragHandle {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .panelDragHandle:hover {\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .slotCellDropActive {\n  background: rgba(59, 130, 246, 0.12);\n  outline-color: #60a5fa;\n}\n[data-theme=\"dark\"] .emptySlotDropActive {\n  background: rgba(59, 130, 246, 0.15) !important;\n  border-color: #60a5fa !important;\n}\n\n[data-theme=\"dark\"] .addPanelTile {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .emptyTab {\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .detachedNotice {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .btnSecondary {\n  background: var(--color-bg-secondary);\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .btnSecondary:hover {\n  background: var(--color-hover);\n}\n\n[data-theme=\"dark\"] .rotationOn {\n  background: rgba(22, 163, 74, 0.2);\n  border-color: #16a34a;\n  color: #86efac;\n}\n\n[data-theme=\"dark\"] .dwellLabel {\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .panelError {\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n}\n\n/* Dark mode */\n@media (prefers-color-scheme: dark) {\n  .modal {\n    background: #374151;\n  }\n\n  .header {\n    border-bottom-color: #4b5563;\n  }\n\n  .header h2 {\n    color: #f3f4f6;\n  }\n\n  .connSelect {\n    background: #4b5563;\n    border-color: #6b7280;\n    color: #f3f4f6;\n  }\n\n  .connSelect:hover {\n    border-color: #3b82f6;\n  }\n\n  .connSelect:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  }\n\n  .refreshBtn,\n  .closeBtn {\n    color: #9ca3af;\n  }\n\n  .refreshBtn:hover:not(:disabled),\n  .closeBtn:hover {\n    background: #4b5563;\n    color: #f3f4f6;\n  }\n\n  .chartSection {\n    background: #4b5563;\n    border-color: #6b7280;\n  }\n\n  .chartSection h3 {\n    color: #f3f4f6;\n  }\n\n  .footer {\n    border-top-color: #4b5563;\n    background: #2d3748;\n  }\n\n  .autoRefreshControl {\n    color: #e5e7eb;\n  }\n\n  .autoRefreshControl label {\n    color: #e5e7eb;\n  }\n\n  .intervalSelect {\n    background: #4b5563;\n    border-color: #6b7280;\n    color: #f3f4f6;\n  }\n\n  .timestamp {\n    color: #9ca3af;\n  }\n}\n\n/* Data theme attribute support */\n[data-theme=\"dark\"] .modal {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .header {\n  background: var(--color-bg-secondary);\n  border-bottom-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .header h2 {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .connSelect {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .connSelect:hover {\n  border-color: var(--color-hover-border, #5a5a5a);\n}\n\n[data-theme=\"dark\"] .connSelect:focus {\n  border-color: var(--color-accent-fg);\n}\n\n[data-theme=\"dark\"] .refreshBtn,\n[data-theme=\"dark\"] .closeBtn {\n  color: var(--color-text-muted);\n}\n\n[data-theme=\"dark\"] .refreshBtn:hover:not(:disabled),\n[data-theme=\"dark\"] .closeBtn:hover {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .chartSection {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n\n[data-theme=\"dark\"] .chartSection h3 {\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .footer {\n  border-top-color: var(--color-border);\n  background: var(--color-bg-secondary);\n}\n\n[data-theme=\"dark\"] .autoRefreshControl {\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .autoRefreshControl label {\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .intervalSelect {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n\n[data-theme=\"dark\"] .timestamp {\n  color: var(--color-text-muted);\n}\n\n/* =================================================================== */\n/* 전체화면 토글 (2026-04-24) — 모달을 브라우저/Electron 창 꽉 채움      */\n/* =================================================================== */\n.modalFullscreen {\n  width: calc(100vw / var(--app-zoom, 1)) !important;\n  height: calc(100vh / var(--app-zoom, 1)) !important;\n  max-width: none !important;\n  border-radius: 0 !important;\n}\n\n/* 전체화면(또는 분리 popup OS-fullscreen) 시 폰트 살짝 키워 가독성 ↑.\n   recharts 는 inline style 로 font-size 박혀있어 !important 로 덮어씀. */\n/* 카드/헤더 패딩을 줄여 차트 영역 최대화 (분리 popup OS-fullscreen 에서 특히 효과 큼) */\n.modalFullscreen .chartSection { padding: 10px 12px; }\n.modalFullscreen .panelHeader { margin-bottom: 6px; }\n.modalFullscreen .slotGrid { gap: 10px; }\n.modalFullscreen .collapsedStrip { margin-top: 8px; padding: 6px 8px; min-height: 36px; }\n/* 패널 제목 — descendant 선택자로 panelHeader > panelTitleWrapper > h3 모두 매칭 */\n.modalFullscreen .chartSection h3 { font-size: 16px; }\n.modalFullscreen .panelPublisherBadge { font-size: 11px; padding: 1px 8px; }\n.modalFullscreen .panelPublisherBadgeValue { font-size: 11px; }\n.modalFullscreen .panelDisabledBody,\n.modalFullscreen .panelWaitingBody { font-size: 13px; }\n.modalFullscreen .panelDisabledBody small,\n.modalFullscreen .panelWaitingBody small { font-size: 12px; }\n.modalFullscreen .panelError { font-size: 13px; padding: 8px 12px; }\n\n/* recharts 내부 텍스트 — inline style 덮기 위해 !important.\n   :global 로 CSS Module hashing 회피해 popup 에 복사된 CSS 에서도 동일하게 작동. */\n.modalFullscreen :global(.recharts-text),\n.modalFullscreen :global(.recharts-cartesian-axis-tick-value),\n.modalFullscreen :global(.recharts-cartesian-axis-tick-value tspan) { font-size: 13px !important; }\n.modalFullscreen :global(.recharts-label),\n.modalFullscreen :global(.recharts-label tspan) { font-size: 14px !important; }\n.modalFullscreen :global(.recharts-legend-wrapper),\n.modalFullscreen :global(.recharts-default-legend),\n.modalFullscreen :global(.recharts-legend-item-text) { font-size: 14px !important; }\n.modalFullscreen :global(.recharts-default-tooltip) { font-size: 13px !important; }\n.fsBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.fsBtn:hover {\n  color: #333;\n}\n[data-theme=\"dark\"] .fsBtn {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .fsBtn:hover {\n  color: var(--color-text);\n}\n\n/* =================================================================== */\n/* 고정 슬롯 그리드 (1x1 / 1x2 / 2x1 / 2x2) — PanelSlotGrid 렌더             */\n/* =================================================================== */\n.slotGrid {\n  display: grid;\n  gap: 16px;\n  width: 100%;\n  align-items: stretch;\n  /* body 의 flex column 안에서 남은 공간을 채워, 셀 행이 1fr 로 화면에 맞게 확장됨 */\n  flex: 1;\n  min-height: 0;\n}\n/* `1fr` = `minmax(auto, 1fr)` 이라 row/column 의 auto min 이 셀 콘텐츠\n   min-height(emptySlot 260px, panelDisabledBody 200px 등)으로 잡혀,\n   popup 같은 좁은 컨테이너에서 grid 가 부모 flex 영역을 초과해 하단\n   collapsedStrip 위로 겹쳐 보이는 문제 발생. minmax(0, 1fr) 로 바꿔\n   row/column 이 자유롭게 줄어들 수 있게 한다 — 자식들은 이미 min-height: 0\n   처리돼 있음. */\n.slotGrid1x1 { grid-template-columns: minmax(0, 1fr); grid-template-rows: minmax(0, 1fr); }\n.slotGrid1x2 { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: minmax(0, 1fr); }\n.slotGrid2x1 { grid-template-columns: minmax(0, 1fr); grid-template-rows: repeat(2, minmax(0, 1fr)); }\n.slotGrid2x2 { grid-template-columns: repeat(2, minmax(0, 1fr)); grid-template-rows: repeat(2, minmax(0, 1fr)); }\n\n/* 비대칭 레이아웃 — 왼쪽에 세로로 긴 패널 + 오른쪽에 2분할 (3 슬롯) */\n.slotGrid1L2R {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-areas:\n    \"L TR\"\n    \"L BR\";\n}\n.slotGrid1L2R > :nth-child(1) { grid-area: L; }\n.slotGrid1L2R > :nth-child(2) { grid-area: TR; }\n.slotGrid1L2R > :nth-child(3) { grid-area: BR; }\n\n/* 비대칭 레이아웃 — 왼쪽에 2분할 + 오른쪽에 세로로 긴 패널 (3 슬롯) */\n.slotGrid2L1R {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);\n  grid-template-areas:\n    \"TL R\"\n    \"BL R\";\n}\n.slotGrid2L1R > :nth-child(1) { grid-area: TL; }\n.slotGrid2L1R > :nth-child(2) { grid-area: BL; }\n.slotGrid2L1R > :nth-child(3) { grid-area: R; }\n\n/* 빈 슬롯 플레이스홀더 — 클릭 시 PanelEditor 오픈 */\n.emptySlot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  background: #fafafa;\n  min-height: 260px;\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 13px;\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\n}\n.emptySlot:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  background: #f3f4ff;\n}\n.emptySlotIcon {\n  font-size: 28px;\n  line-height: 1;\n}\n.emptySlotLabel {\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n.emptySlotHint {\n  font-size: 11px;\n  color: #9ca3af;\n  letter-spacing: 0.2px;\n}\n[data-theme=\"dark\"] .emptySlotHint { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .emptySlot {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .emptySlot:hover {\n  border-color: var(--color-hover-border, #5a5a5a);\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n\n/* 슬롯 초과 패널 안내 배너 */\n.slotOverflowNotice {\n  padding: 10px 14px;\n  margin-top: 12px;\n  font-size: 12px;\n  color: #92400e;\n  background: #fef3c7;\n  border: 1px solid #fde68a;\n  border-radius: 6px;\n  line-height: 1.5;\n}\n[data-theme=\"dark\"] .slotOverflowNotice {\n  color: #fbbf24;\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.3);\n}\n\n/* =================================================================== */\n/* 설정 탭 (⚙ 설정) — 탭별 레이아웃 관리                                */\n/* =================================================================== */\n.settingsTab {\n  padding: 4px 4px 20px;\n}\n.settingsTab h3 {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n.settingsTab p {\n  margin: 0 0 16px;\n  font-size: 12px;\n  color: #6b7280;\n}\n.settingsTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.settingsTable th {\n  text-align: left;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n  font-weight: 600;\n  color: #374151;\n}\n.settingsTable td {\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n  vertical-align: middle;\n}\n.settingsRowDisabled {\n  opacity: 0.55;\n}\n.settingsRowDisabled td {\n  cursor: not-allowed;\n}\n.tabKindBadge {\n  display: inline-block;\n  padding: 2px 8px;\n  font-size: 11px;\n  border-radius: 10px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-weight: 500;\n}\n.tabKindBadge.kindBuiltin { background: #dbeafe; color: #1e3a8a; }\n.tabKindBadge.kindCustom  { background: #fce7f3; color: #9d174d; }\n.tabKindBadge.kindUser    { background: #dcfce7; color: #166534; }\n.tabKindBadge.kindOverview { background: #e5e7eb; color: #4b5563; }\n\n/* 탭 버튼 내부의 인라인 아이콘 (텍스트 좌측 여백·중앙 정렬) */\n.tabIcon {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 5px;\n  color: inherit;\n  opacity: 0.85;\n}\n.tabIcon > svg { flex-shrink: 0; }\n\n/* 쿼리 템플릿 매니저 — 차트 타입별 필터 탭 */\n.chartFilterTabs {\n  display: flex;\n  gap: 6px;\n  margin: 8px 0 12px;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 6px;\n}\n.chartFilterTab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #6b7280;\n  border-radius: 6px 6px 0 0;\n  font-size: 12px;\n  cursor: pointer;\n  transition: border-color 0.12s, color 0.12s, background 0.12s;\n}\n.chartFilterTab:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n.chartFilterTabActive {\n  color: #1d4ed8;\n  background: #dbeafe;\n  border-color: #93c5fd;\n  font-weight: 600;\n}\n.chartFilterTabCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  background: #e5e7eb;\n  color: #4b5563;\n  border-radius: 9px;\n  font-size: 10px;\n  font-weight: 600;\n}\n.chartFilterTabActive .chartFilterTabCount {\n  background: #1d4ed8;\n  color: #fff;\n}\n[data-theme=\"dark\"] .chartFilterTabs {\n  border-bottom-color: var(--color-border);\n}\n[data-theme=\"dark\"] .chartFilterTab {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .chartFilterTab:hover {\n  color: var(--color-text);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .chartFilterTabActive {\n  color: #93c5fd;\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.3);\n}\n[data-theme=\"dark\"] .chartFilterTabCount {\n  background: var(--color-bg-secondary);\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .chartFilterTabActive .chartFilterTabCount {\n  background: #60a5fa;\n  color: var(--color-bg);\n}\n\n/* 설정 탭 하단 액션 영역 */\n.settingsActions {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* 인라인 편집 그룹 (이름 변경 / 신규 탭 입력) */\n.inlineEditGroup {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.inlineInput {\n  padding: 5px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 13px;\n  min-width: 180px;\n  outline: none;\n  background: #fff;\n  color: #111827;\n}\n.inlineInput:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n/* 작은 아이콘 버튼 (편집/저장/취소/삭제) */\n.iconBtn, .iconBtnConfirm, .iconBtnDanger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #6b7280;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  transition: border-color 0.12s, color 0.12s, background 0.12s;\n}\n.iconBtn:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n.iconBtnConfirm {\n  background: #10b981;\n  border-color: #10b981;\n  color: #fff;\n}\n.iconBtnConfirm:hover {\n  background: #059669;\n  border-color: #059669;\n}\n.iconBtnDanger:hover {\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n/* 위험한 작업 확정 버튼 (인라인 2단계 삭제 확인) */\n.iconBtnConfirmDanger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  height: 26px;\n  min-width: 48px;\n  border: 1px solid #ef4444;\n  background: #ef4444;\n  color: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  transition: background 0.12s, border-color 0.12s;\n}\n.iconBtnConfirmDanger:hover {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n.rowActions {\n  display: inline-flex;\n  gap: 4px;\n}\n\n/* Overview 탭의 DataSource 선택 바 */\n.overviewDsBar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n.overviewDsBar label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #374151;\n}\n.overviewWarn {\n  color: #92400e;\n  font-size: 12px;\n}\n.overviewEmpty {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6b7280;\n}\n[data-theme=\"dark\"] .overviewDsBar {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .overviewDsBar label { color: var(--color-text); }\n[data-theme=\"dark\"] .overviewEmpty { color: var(--color-text-muted); }\n\n/* DataSource \"기본\" 배지 (설정 탭의 DS 목록) */\n.dsDefaultBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  font-size: 10px;\n  border-radius: 10px;\n  background: #fef3c7;\n  color: #92400e;\n  font-weight: 600;\n  margin-left: 6px;\n}\n[data-theme=\"dark\"] .dsDefaultBadge {\n  background: rgba(245, 158, 11, 0.2);\n  color: #fbbf24;\n}\n\n/* 보이기/숨기기 토글 — 눈 아이콘 */\n.visibilityToggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 28px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #3b82f6;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  transition: border-color 0.12s, color 0.12s, background 0.12s;\n}\n.visibilityToggle:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n.visibilityToggle.visibilityHidden {\n  color: #9ca3af;\n  background: #f3f4f6;\n}\n.visibilityToggle.visibilityHidden:hover {\n  color: #6b7280;\n  background: #e5e7eb;\n}\n[data-theme=\"dark\"] .visibilityToggle {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: #60a5fa;\n}\n[data-theme=\"dark\"] .visibilityToggle:hover {\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .visibilityToggle.visibilityHidden {\n  color: var(--color-text-muted);\n  background: var(--color-bg);\n}\n\n[data-theme=\"dark\"] .tabKindBadge.kindUser { background: rgba(34, 197, 94, 0.2); color: #86efac; }\n[data-theme=\"dark\"] .inlineInput {\n  background: var(--color-input-bg);\n  border-color: var(--color-input-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .iconBtn, [data-theme=\"dark\"] .iconBtnDanger {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .iconBtn:hover {\n  color: var(--color-text);\n  border-color: var(--color-hover-border, #5a5a5a); background: var(--color-hover);}\n[data-theme=\"dark\"] .iconBtnDanger:hover {\n  color: #f87171;\n  border-color: #f87171;\n}\n\n[data-theme=\"dark\"] .settingsTab h3 { color: var(--color-text); }\n[data-theme=\"dark\"] .settingsTab p  { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .settingsTable th {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .settingsTable td {\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .tabKindBadge { background: rgba(99, 102, 241, 0.2); color: #a5b4fc; }\n[data-theme=\"dark\"] .tabKindBadge.kindBuiltin { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }\n[data-theme=\"dark\"] .tabKindBadge.kindCustom  { background: rgba(236, 72, 153, 0.2); color: #f9a8d4; }\n[data-theme=\"dark\"] .tabKindBadge.kindOverview { background: rgba(156, 163, 175, 0.2); color: #d1d5db; }\n\n/* =================================================================== */\n/* LayoutSelector — 4+1 (auto) 아이콘 라디오 그룹                        */\n/* =================================================================== */\n.layoutSelector {\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n}\n.layoutOption {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 32px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  padding: 4px;\n  transition: border-color 0.12s, background 0.12s;\n}\n.layoutOption:hover:not(:disabled) {\n  border-color: #93c5fd;\n  background: #eff6ff;\n}\n.layoutOptionActive {\n  border-color: #3b82f6 !important;\n  background: #dbeafe !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n.layoutOption:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.layoutOptionAuto {\n  width: auto;\n  padding: 4px 10px;\n  font-size: 12px;\n  color: #374151;\n}\n.layoutIcon {\n  display: grid;\n  gap: 2px;\n  width: 22px;\n  height: 18px;\n}\n.layoutIcon span {\n  background: #6b7280;\n  border-radius: 1px;\n  display: block;\n}\n.layoutOptionActive .layoutIcon span {\n  background: #1d4ed8;\n}\n[data-theme=\"dark\"] .layoutOption {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n}\n[data-theme=\"dark\"] .layoutOption:hover:not(:disabled) {\n  border-color: var(--color-hover-border, #5a5a5a);\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .layoutOptionActive {\n  background: rgba(59, 130, 246, 0.2) !important;\n}\n[data-theme=\"dark\"] .layoutOptionAuto {\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .layoutIcon span { background: #9ca3af; }\n[data-theme=\"dark\"] .layoutOptionActive .layoutIcon span { background: #60a5fa; }\n\n/* ===== 최근 창(자원·세션·성능 분석·카탈로그)과 모양 맞춤 (2026-10-03) =====\n   앞의 규칙을 지우지 않고 뒤에서 덮는다 — 분리 창(팝업)·전체 화면 규칙이 같은 클래스를 쓴다.\n   - 탭은 둥근 리본(고른 것 = 파란 테두리·옅은 파랑 바탕·굵은 글자). 로테이션 체크·분리 버튼은 리본 안에 둔다\n   - 글자·여백은 12px 계열로(다른 창들과 같은 밀도) */\n.tabBar {\n  gap: 6px;\n  padding: 8px 16px;\n  background: transparent;\n  border-bottom: 1px solid #e5e7eb;\n}\n.tabItem {\n  gap: 2px;\n  padding: 1px 8px 1px 2px;\n  border-radius: 999px;\n  border-color: #d1d5db;\n  background: #fff;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n.tabItem:hover { border-color: #3b82f6; }\n.tabActive { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); }\n.tabMain { font-size: 12px; padding: 3px 6px; color: #4b5563; }\n.tabActive .tabMain { color: #1d4ed8; font-weight: 600; }\n.tabActionBtn { border-radius: 999px; }\n.header h2 { font-size: 14px; }\n.headerControls { gap: 8px; }\n.connSelect { padding: 3px 8px; font-size: 12px; border-radius: 4px; min-width: 0; }\n.syncCheckLabel { font-size: 12px; }\n.chartSection { padding: 10px 12px; }\n.panelHeader { margin-bottom: 6px; }\n.panelHeader h3 { font-size: 12px; }\n.footer { padding: 10px 16px; }\n.autoRefreshControl { font-size: 12px; gap: 8px; }\n.intervalSelect { padding: 3px 8px; font-size: 12px; }\n.btnSecondary { font-size: 12px; }\n[data-theme=\"dark\"] .tabBar { background: transparent; border-bottom-color: var(--color-border); }\n[data-theme=\"dark\"] .tabItem { background: var(--color-btn-bg); border-color: var(--color-btn-border); }\n[data-theme=\"dark\"] .tabActive { background: rgba(59, 130, 246, 0.18); border-color: var(--color-accent-fg); }\n[data-theme=\"dark\"] .tabMain { color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .tabActive .tabMain { color: #93c5fd; }\n@media (prefers-reduced-motion: reduce) { .tabItem { transition: none; } }\n\n/* 기본 탭 → 분석 창 바로가기(2026-10-03) */\n.relatedBar { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin: 0 0 10px; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 6px; background: #f9fafb; font-size: 12px; animation: dashFadeIn 160ms ease-out; }\n.relatedNote { color: #6b7280; margin-right: 4px; }\n.relatedBtn { display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border: 1px solid #d1d5db; border-radius: 999px; background: #fff; color: #1d4ed8; font-size: 12px; cursor: pointer; transition: background-color 150ms ease, border-color 150ms ease; }\n.relatedBtn:hover { border-color: #3b82f6; background: rgba(59, 130, 246, 0.08); }\n@keyframes dashFadeIn { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\n[data-theme=\"dark\"] .relatedBar { background: var(--color-bg-secondary); border-color: var(--color-border); }\n[data-theme=\"dark\"] .relatedNote { color: var(--color-text-muted); }\n[data-theme=\"dark\"] .relatedBtn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: #93c5fd; }\n@media (prefers-reduced-motion: reduce) { .relatedBar { animation: none; } .relatedBtn { transition: none; } }\n\n/* 구독한 대시보드 표시(2026-10-03) */\n.subscribedBadge { display: inline-flex; align-items: center; gap: 3px; margin-left: 8px; padding: 0 7px; border-radius: 999px; background: #eff6ff; color: #1d4ed8; font-size: 10.5px; font-weight: 600; }\n[data-theme=\"dark\"] .subscribedBadge { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }\n\n/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====\n   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.\n   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */\n.body { padding: 12px 16px; gap: 12px; font-size: 12px; }\n.btnPrimary, .btnSecondary {\n  height: 30px; box-sizing: border-box; padding: 0 14px; border-radius: 6px;\n  font-size: 13px; line-height: 1; gap: 6px;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.btnSecondary { background: #e5e7eb; border-color: #d1d5db; color: #374151; }\n.btnSecondary:hover { background: #d1d5db; }\n.btnPrimary > svg, .btnSecondary > svg { display: block; flex-shrink: 0; margin: 0 !important; }\n.settingsTab { padding: 0 0 12px; }\n.settingsTab h3 { font-size: 13px; }\n.settingsTable { font-size: 12px; }\n.settingsTable th { padding: 6px 8px; border-bottom: 2px solid #d0d5db; color: #333; white-space: nowrap; }\n.settingsTable td { padding: 5px 8px; border-bottom: 1px solid #eee; color: #374151; }\n.tabKindBadge { padding: 1px 8px; border-radius: 999px; font-size: 10.5px; }\n.inlineInput { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }\n.iconBtn, .iconBtnDanger { transition: background-color 150ms ease, color 150ms ease; }\n.chartFilterTabs { flex-wrap: wrap; border-bottom: none; padding-bottom: 0; margin: 4px 0 10px; }\n.chartFilterTab {\n  padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 999px; background: #fff; color: #4b5563;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.chartFilterTab:hover { border-color: #3b82f6; }\n.chartFilterTabActive { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }\n[data-theme=\"dark\"] .btnSecondary { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text); }\n[data-theme=\"dark\"] .btnSecondary:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .settingsTable th { border-bottom-color: var(--color-border); color: var(--color-text); }\n[data-theme=\"dark\"] .settingsTable td { border-bottom-color: var(--color-border); color: var(--color-text); }\n[data-theme=\"dark\"] .chartFilterTab { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\n[data-theme=\"dark\"] .chartFilterTabActive { border-color: var(--color-accent-fg); background: rgba(59, 130, 246, 0.18); color: #93c5fd; }\n@media (prefers-reduced-motion: reduce) { .btnPrimary, .btnSecondary, .chartFilterTab, .iconBtn, .iconBtnDanger { transition: none; } }\n\n/* 수집 미등록 안내 — 그래프가 왜 비었는지와 가는 길 */\n.collectBanner { display: flex; align-items: center; gap: 10px; margin: 0 0 10px; padding: 10px 14px; border-radius: 6px; background: #fffbeb; border: 1px solid #fcd34d; color: #92400e; font-size: 12.5px; animation: collect-banner-fade 160ms ease-out; }\n.collectBanner span { flex: 1; }\n@keyframes collect-banner-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\n:global([data-theme=\"dark\"]) .collectBanner { background: rgba(146, 64, 14, 0.25); border-color: #92400e; color: #fde68a; }\n@media (prefers-reduced-motion: reduce) { .collectBanner { animation: none; } }\n\n/* ===== 한 화면에 — 스크롤 없는 대시보드(2026-10-18) =====\n   순환·관제 화면은 한눈에 보여야 한다. 패널 탭의 본문은 스크롤하지 않고, 격자가 남은 높이를 꼭 채운다(행은 minmax(0, 1fr)).\n   패널이 늘면 행이 늘어나는 대신 칸이 작아진다. 접힌 패널 줄은 한 줄 — 넘치는 카드는 감춘다(줄바꿈하면 길어진다) */\n.bodyFit { overflow: hidden; }\n.bodyFit .panelGrid { overflow: hidden; grid-auto-rows: unset; }\n/* 카드의 padding·border 가 높이 100% 에 **더해지면** 칸보다 커져 아래(범례)가 잘린다 — 고정 배치의 slotCell 과 같이 border-box */\n.bodyFit .panelGrid > * { min-height: 0; min-width: 0; box-sizing: border-box; }\n.bodyFit .panelGrid .chartSection,\n.bodyFit .panelDisabledBody,\n.bodyFit .panelWaitingBody,\n.bodyFit .emptySlot { min-height: 0; }\n.bodyFit .collapsedStrip { flex-wrap: nowrap; overflow: hidden; }\n/* 자동 배치의 「패널 추가」 줄 — 칸을 차지하지 않게 얇게(접힌 패널 줄 모양을 쓰면 44px + 여백으로 화면을 먹었다) */\n.addBar { flex-shrink: 0; display: flex; align-items: center; justify-content: flex-start; margin-top: 8px; }\n\n/* 순환 전환 효과의 그릇(2026-10-18) — 패널 격자·접힌 줄을 그대로 담는다(body 의 세로 배치·간격을 물려받는다).\n   애니메이션은 화면(Web Animations)이 건다 — 동작 줄이기 설정이면 걸지 않는다 */\n.slideStage { position: relative; flex: 1; min-height: 0; overflow: hidden; gap: inherit; }\n/* 층은 무대를 꽉 채운다 — 미리 그리는 층도 크기를 가져야 차트가 제 크기로 그려진다(visibility 로만 감춘다) */\n.slideLayer { position: absolute; inset: 0; display: flex; flex-direction: column; gap: inherit; backface-visibility: hidden; background: #fff; }\n/* 층마다 창과 같은 바탕 — 없으면 새 화면의 패널 사이 틈으로 앞 화면이 비친다(화면 확인 2026-10-18) */\n[data-theme=\"dark\"] .slideLayer { background: var(--color-bg-tertiary); }\n.slideLayerActive { z-index: 2; }\n.slideLayerLeaving { z-index: 1; pointer-events: none; }\n.slideLayerPreload { z-index: 0; visibility: hidden; pointer-events: none; }\n\n/* 설정 탭의 「순환」 칸 — 체크 · 순서 · ▲▼ (2026-10-18) */\n.rotationCell { display: flex; align-items: center; gap: 4px; white-space: nowrap; }\n.rotationPos { min-width: 2.2em; font-size: 12px; font-variant-numeric: tabular-nums; color: var(--color-text-muted, #6b7280); }\n.rotationCell .iconBtn:disabled { opacity: 0.35; cursor: default; }\n\n/* 일시 구간(2026-10-28) — 「직접 지정」 을 고르면 머리줄에 시작·끝 입력이 선다 */\n.rangeBox {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  animation: dash-range-fade 150ms ease-out;\n}\n.rangeBox input[type=\"datetime-local\"] {\n  padding: 6px 6px;\n  border: 1px solid var(--color-border, #d1d5db);\n  border-radius: 6px;\n  font-size: 12px;\n  color: var(--color-text, #374151);\n  background: var(--color-bg, #fff);\n}\n@keyframes dash-range-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\n@media (prefers-reduced-motion: reduce) {\n  .rangeBox { animation: none; }\n}\n\n/* 쿼리 템플릿 — 왼쪽 목록 · 오른쪽 내용(2026-10-28) */\n.qtmSplit { display: flex; flex: 1; min-height: 0; gap: 10px; }\n.qtmList { flex: 0 0 46%; min-width: 280px; overflow-y: auto; border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px; }\n.qtmRow { cursor: pointer; transition: background-color 150ms ease; }\n.qtmRow:hover { background: var(--color-hover, rgba(0, 0, 0, 0.04)); }\n.qtmRowActive, .qtmRowActive:hover { background: color-mix(in srgb, #3b82f6 14%, transparent); }\n.qtmDetail { flex: 1; min-width: 0; overflow: auto; border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px; }\n.qtmEmpty { padding: 24px; color: var(--color-text-muted, #6b7280); text-align: center; font-size: 13px; }\n.qtmDetailBody { padding: 12px 14px; display: flex; flex-direction: column; gap: 8px; animation: qtm-fade 150ms ease-out; }\n.qtmDetailHead { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 14px; }\n.qtmDesc { margin: 0; font-size: 12px; color: var(--color-text-secondary, #555); line-height: 1.5; }\n.qtmFields { display: flex; gap: 12px; font-size: 12px; color: var(--color-text-secondary, #555); }\n.qtmSql {\n  margin: 0; padding: 10px 12px; font-family: var(--font-mono, Consolas, monospace); font-size: 12px; line-height: 1.5;\n  background: var(--color-bg-secondary, #f8fafc); border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px;\n  white-space: pre; overflow: auto; max-height: 420px; color: var(--color-text, #222);\n}\n.qtmActions { display: flex; gap: 6px; flex-wrap: wrap; }\n@keyframes qtm-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\n@media (prefers-reduced-motion: reduce) {\n  .qtmDetailBody { animation: none; }\n  .qtmRow { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `MonitoringDashboardModal_overlay__NmG5Y`,
	"modal": `MonitoringDashboardModal_modal__LDvh2`,
	"header": `MonitoringDashboardModal_header__f48Tr`,
	"headerControls": `MonitoringDashboardModal_headerControls__+mfLN`,
	"connSelect": `MonitoringDashboardModal_connSelect__GQVPX`,
	"syncCheckLabel": `MonitoringDashboardModal_syncCheckLabel__oKpgM`,
	"refreshBtn": `MonitoringDashboardModal_refreshBtn__5NDuB`,
	"closeBtn": `MonitoringDashboardModal_closeBtn__ygfjU`,
	"spin": `MonitoringDashboardModal_spin__LOZV4`,
	"body": `MonitoringDashboardModal_body__u+tuT`,
	"metricsGrid": `MonitoringDashboardModal_metricsGrid__U+tgx`,
	"chartsContainer": `MonitoringDashboardModal_chartsContainer__kQdh1`,
	"chartSection": `MonitoringDashboardModal_chartSection__PVQWu`,
	"panelChartWrapper": `MonitoringDashboardModal_panelChartWrapper__1FyDy`,
	"noData": `MonitoringDashboardModal_noData__AWw1I`,
	"footer": `MonitoringDashboardModal_footer__zHwI4`,
	"autoRefreshControl": `MonitoringDashboardModal_autoRefreshControl__dSNhm`,
	"intervalSelect": `MonitoringDashboardModal_intervalSelect__KtBFH`,
	"timestamp": `MonitoringDashboardModal_timestamp__kXY8g`,
	"tabBar": `MonitoringDashboardModal_tabBar__Sulzk`,
	"tabItem": `MonitoringDashboardModal_tabItem__THfAv`,
	"tabActive": `MonitoringDashboardModal_tabActive__NPiHX`,
	"tabMain": `MonitoringDashboardModal_tabMain__o9NY0`,
	"tabRotationLabel": `MonitoringDashboardModal_tabRotationLabel__HqIAv`,
	"tabActionBtn": `MonitoringDashboardModal_tabActionBtn__bSNpv`,
	"panelGrid": `MonitoringDashboardModal_panelGrid__OxzGj`,
	"panelHeader": `MonitoringDashboardModal_panelHeader__tig-2`,
	"panelTitleWrapper": `MonitoringDashboardModal_panelTitleWrapper__OBtmv`,
	"panelDragHandle": `MonitoringDashboardModal_panelDragHandle__nTtm7`,
	"chartSectionDragging": `MonitoringDashboardModal_chartSectionDragging__Nd64p`,
	"slotCell": `MonitoringDashboardModal_slotCell__iH6V3`,
	"slotCellDropActive": `MonitoringDashboardModal_slotCellDropActive__F+5q0`,
	"emptySlot": `MonitoringDashboardModal_emptySlot__Qt8mm`,
	"panelDisabledBody": `MonitoringDashboardModal_panelDisabledBody__tCExE`,
	"panelWaitingBody": `MonitoringDashboardModal_panelWaitingBody__TY+z-`,
	"emptySlotDropActive": `MonitoringDashboardModal_emptySlotDropActive__6mEyt`,
	"collapsedStrip": `MonitoringDashboardModal_collapsedStrip__rzfXC`,
	"collapsedStripDropActive": `MonitoringDashboardModal_collapsedStripDropActive__v594t`,
	"collapsedStripHint": `MonitoringDashboardModal_collapsedStripHint__n9eIg`,
	"collapsedCard": `MonitoringDashboardModal_collapsedCard__p7r4e`,
	"collapsedCardDragging": `MonitoringDashboardModal_collapsedCardDragging__1vbAV`,
	"collapsedCardDisabled": `MonitoringDashboardModal_collapsedCardDisabled__1EWrH`,
	"collapsedCardDragHandle": `MonitoringDashboardModal_collapsedCardDragHandle__mfwvu`,
	"collapsedCardTitle": `MonitoringDashboardModal_collapsedCardTitle__hE3eF`,
	"collapsedAddBtn": `MonitoringDashboardModal_collapsedAddBtn__1Cd6K`,
	"panelEditBtn": `MonitoringDashboardModal_panelEditBtn__HELeB`,
	"panelToggleBtn": `MonitoringDashboardModal_panelToggleBtn__kMhdj`,
	"panelToggleBtnOn": `MonitoringDashboardModal_panelToggleBtnOn__gNzT0`,
	"chartSectionDisabled": `MonitoringDashboardModal_chartSectionDisabled__86h2X`,
	"panelToggleFade": `MonitoringDashboardModal_panelToggleFade__bAPG-`,
	"panelPublisherBadge": `MonitoringDashboardModal_panelPublisherBadge__YzLUD`,
	"panelPublisherBadgeValue": `MonitoringDashboardModal_panelPublisherBadgeValue__HKWwK`,
	"sqlViewOverlay": `MonitoringDashboardModal_sqlViewOverlay__xDoBa`,
	"sqlViewFadeIn": `MonitoringDashboardModal_sqlViewFadeIn__vyH5m`,
	"sqlViewModal": `MonitoringDashboardModal_sqlViewModal__xUlUG`,
	"sqlViewSlide": `MonitoringDashboardModal_sqlViewSlide__YfcvO`,
	"sqlViewHeader": `MonitoringDashboardModal_sqlViewHeader__9OWmt`,
	"sqlViewTitle": `MonitoringDashboardModal_sqlViewTitle__ibICS`,
	"sqlViewActions": `MonitoringDashboardModal_sqlViewActions__yImBm`,
	"sqlViewIconBtn": `MonitoringDashboardModal_sqlViewIconBtn__BTEj4`,
	"sqlViewSubheader": `MonitoringDashboardModal_sqlViewSubheader__ufb-D`,
	"sqlViewBody": `MonitoringDashboardModal_sqlViewBody__2iMUP`,
	"mergedStack": `MonitoringDashboardModal_mergedStack__ei8d9`,
	"mergedItem": `MonitoringDashboardModal_mergedItem__Sleqs`,
	"mergedSubTitle": `MonitoringDashboardModal_mergedSubTitle__ztm54`,
	"mergedEmpty": `MonitoringDashboardModal_mergedEmpty__rw45i`,
	"panelError": `MonitoringDashboardModal_panelError__X26Bk`,
	"addPanelTile": `MonitoringDashboardModal_addPanelTile__uY70f`,
	"emptyTab": `MonitoringDashboardModal_emptyTab__bXeot`,
	"detachedNotice": `MonitoringDashboardModal_detachedNotice__M5dva`,
	"btnPrimary": `MonitoringDashboardModal_btnPrimary__Uu36a`,
	"btnSecondary": `MonitoringDashboardModal_btnSecondary__VZX2I`,
	"rotationOn": `MonitoringDashboardModal_rotationOn__Oy1u3`,
	"rotationControl": `MonitoringDashboardModal_rotationControl__e10Xe`,
	"dwellLabel": `MonitoringDashboardModal_dwellLabel__kQA26`,
	"modalFullscreen": `MonitoringDashboardModal_modalFullscreen__L247B`,
	"slotGrid": `MonitoringDashboardModal_slotGrid__ximDU`,
	"fsBtn": `MonitoringDashboardModal_fsBtn__dfbYQ`,
	"slotGrid1x1": `MonitoringDashboardModal_slotGrid1x1__j22V3`,
	"slotGrid1x2": `MonitoringDashboardModal_slotGrid1x2__Eu7A6`,
	"slotGrid2x1": `MonitoringDashboardModal_slotGrid2x1__vpair`,
	"slotGrid2x2": `MonitoringDashboardModal_slotGrid2x2__GGQbX`,
	"slotGrid1L2R": `MonitoringDashboardModal_slotGrid1L2R__NUQbW`,
	"slotGrid2L1R": `MonitoringDashboardModal_slotGrid2L1R__WBeLb`,
	"emptySlotIcon": `MonitoringDashboardModal_emptySlotIcon__zp07X`,
	"emptySlotLabel": `MonitoringDashboardModal_emptySlotLabel__CHenm`,
	"emptySlotHint": `MonitoringDashboardModal_emptySlotHint__UAHZo`,
	"slotOverflowNotice": `MonitoringDashboardModal_slotOverflowNotice__efTa6`,
	"settingsTab": `MonitoringDashboardModal_settingsTab__gWal5`,
	"settingsTable": `MonitoringDashboardModal_settingsTable__dygzk`,
	"settingsRowDisabled": `MonitoringDashboardModal_settingsRowDisabled__ZXYYx`,
	"tabKindBadge": `MonitoringDashboardModal_tabKindBadge__11FHG`,
	"kindBuiltin": `MonitoringDashboardModal_kindBuiltin__4Iwgn`,
	"kindCustom": `MonitoringDashboardModal_kindCustom__ab2eG`,
	"kindUser": `MonitoringDashboardModal_kindUser__C+REy`,
	"kindOverview": `MonitoringDashboardModal_kindOverview__4ggPi`,
	"tabIcon": `MonitoringDashboardModal_tabIcon__e1ZyH`,
	"chartFilterTabs": `MonitoringDashboardModal_chartFilterTabs__mOHbT`,
	"chartFilterTab": `MonitoringDashboardModal_chartFilterTab__aAHP0`,
	"chartFilterTabActive": `MonitoringDashboardModal_chartFilterTabActive__Q2Ekt`,
	"chartFilterTabCount": `MonitoringDashboardModal_chartFilterTabCount__bVmMJ`,
	"settingsActions": `MonitoringDashboardModal_settingsActions__Ag2XO`,
	"inlineEditGroup": `MonitoringDashboardModal_inlineEditGroup__OnRzZ`,
	"inlineInput": `MonitoringDashboardModal_inlineInput__UvTMo`,
	"iconBtn": `MonitoringDashboardModal_iconBtn__0gu04`,
	"iconBtnConfirm": `MonitoringDashboardModal_iconBtnConfirm__1Z-V3`,
	"iconBtnDanger": `MonitoringDashboardModal_iconBtnDanger__4+P+2`,
	"iconBtnConfirmDanger": `MonitoringDashboardModal_iconBtnConfirmDanger__+7sZt`,
	"rowActions": `MonitoringDashboardModal_rowActions__sgqqM`,
	"overviewDsBar": `MonitoringDashboardModal_overviewDsBar__P4Pm5`,
	"overviewWarn": `MonitoringDashboardModal_overviewWarn__cEFT4`,
	"overviewEmpty": `MonitoringDashboardModal_overviewEmpty__9n3mg`,
	"dsDefaultBadge": `MonitoringDashboardModal_dsDefaultBadge__inWen`,
	"visibilityToggle": `MonitoringDashboardModal_visibilityToggle__eEWPB`,
	"visibilityHidden": `MonitoringDashboardModal_visibilityHidden__H-dxf`,
	"layoutSelector": `MonitoringDashboardModal_layoutSelector__ySbzE`,
	"layoutOption": `MonitoringDashboardModal_layoutOption__z319j`,
	"layoutOptionActive": `MonitoringDashboardModal_layoutOptionActive__rmLTT`,
	"layoutOptionAuto": `MonitoringDashboardModal_layoutOptionAuto__TZUtG`,
	"layoutIcon": `MonitoringDashboardModal_layoutIcon__1ZVeq`,
	"relatedBar": `MonitoringDashboardModal_relatedBar__7hJhM`,
	"dashFadeIn": `MonitoringDashboardModal_dashFadeIn__x8G+M`,
	"relatedNote": `MonitoringDashboardModal_relatedNote__3nLP6`,
	"relatedBtn": `MonitoringDashboardModal_relatedBtn__Kn9ue`,
	"subscribedBadge": `MonitoringDashboardModal_subscribedBadge__-YY7q`,
	"collectBanner": `MonitoringDashboardModal_collectBanner__qY813`,
	"collect-banner-fade": `MonitoringDashboardModal_collect-banner-fade__gREUf`,
	"bodyFit": `MonitoringDashboardModal_bodyFit__4j7pO`,
	"addBar": `MonitoringDashboardModal_addBar__4F6oP`,
	"slideStage": `MonitoringDashboardModal_slideStage__zegOX`,
	"slideLayer": `MonitoringDashboardModal_slideLayer__tncJ+`,
	"slideLayerActive": `MonitoringDashboardModal_slideLayerActive__tWvrA`,
	"slideLayerLeaving": `MonitoringDashboardModal_slideLayerLeaving__kDEXx`,
	"slideLayerPreload": `MonitoringDashboardModal_slideLayerPreload__d-NBY`,
	"rotationCell": `MonitoringDashboardModal_rotationCell__hJzti`,
	"rotationPos": `MonitoringDashboardModal_rotationPos__AZpoL`,
	"rangeBox": `MonitoringDashboardModal_rangeBox__pXa3V`,
	"dash-range-fade": `MonitoringDashboardModal_dash-range-fade__sje8A`,
	"qtmSplit": `MonitoringDashboardModal_qtmSplit__RtQpr`,
	"qtmList": `MonitoringDashboardModal_qtmList__hQXYb`,
	"qtmRow": `MonitoringDashboardModal_qtmRow__8HI3w`,
	"qtmRowActive": `MonitoringDashboardModal_qtmRowActive__noaX6`,
	"qtmDetail": `MonitoringDashboardModal_qtmDetail__60ywv`,
	"qtmEmpty": `MonitoringDashboardModal_qtmEmpty__fosme`,
	"qtmDetailBody": `MonitoringDashboardModal_qtmDetailBody__Q4eFM`,
	"qtm-fade": `MonitoringDashboardModal_qtm-fade__CdA25`,
	"qtmDetailHead": `MonitoringDashboardModal_qtmDetailHead__On8GZ`,
	"qtmDesc": `MonitoringDashboardModal_qtmDesc__ZxDYs`,
	"qtmFields": `MonitoringDashboardModal_qtmFields__OfSG9`,
	"qtmSql": `MonitoringDashboardModal_qtmSql__deI57`,
	"qtmActions": `MonitoringDashboardModal_qtmActions__4QsFd`
};
export default ___CSS_LOADER_EXPORT___;
